module.exports={
  "LEFT": "Izquierda",
  "CENTER": "Centrado",
  "RIGHT": "Derecha",
  "LOGIN": {
    "SUBMIT": "Ingresar",
    "PASSWORD": "Contraseña",
    "FORGOT_PASSWORD": "Olvide mi contraseña",
    "SHOW_PASSWORD": "Mostrar contraseña",
    "HIDE_PASSWORD": "Ocultar contraseña",
    "PROGRESS": {
      "LOADING_PROFILE": "Cargando perfil de usuario...",
      "VERIFYING_PERMISSIONS": "Verificando permisos...",
      "LOADING_CONFIG": "Cargando configuración...",
      "LOADING_DEPARTMENTS": "Cargando departamentos...",
      "REDIRECTING": "Redirigiendo..."
    }
  },
  "WAITING": {
    "LOGOUT": "Cerrar sesión",
    "BOOT_LOADING": "Cargando aplicación..."
  },
  "LOADING_DIRECTIVE": {
    "LOADING": "Cargando datos..."
  },
  "CALENDAR": {
    "CURRENT-TEXT": "Hoy",
    "LUNES": "Lunes",
    "MARTES": "Martes",
    "MIERCOLES": "Miercoles",
    "JUEVES": "Jueves",
    "VIERNES": "Viernes",
    "SABADO": "Sabado",
    "DOMINGO": "Domingo",
    "DAILY": "Diariamente",
    "WEEKLY": "Semanalmente"
  },
  "AGGRID": {
    "PAGE": "Página",
    "MORE": "Más",
    "TO": "hasta",
    "OF": "de",
    "NEXT": "Siguiente",
    "LAST": "Última",
    "FIRST": "Primera",
    "PREVIOUS": "Anterior",
    "LOADING": "Cargando...",
    "SELECTALL": "Seleccionar todo",
    "SEARCH": "Buscar...",
    "BLANKS": "Vacio",
    "EQUAL": "Igual",
    "LESSTHAN": "Menor",
    "BETWEEN": "Entre",
    "GREATERTHAN": "Mayor",
    "APPLYFILTER": "Aceptar filtro",
    "REMOVEFILTER": "Quitar filtro",
    "FILTER": "Filtro",
    "CONTAINS": "Contiene",
    "STARTWITH": "Empieza con",
    "ENDWITH": "Termina con",
    "GROUP": "Grupo",
    "COLUMNS": "Columna",
    "GROUPCOLUMNS": "Grupo columna",
    "GROUPCOLS_EMPTY": "Arrastrar columnas",
    "VALUECOLUMNS": "Valor columna",
    "VALUECOLS_EMPTY": "Arrastrar columnas"
  },
  "DASHBOARD": {
    "VALIDATIONS": "Validaciones",
    "SITES": "Sitios",
    "DEPARTMENTS": "Departamentos",
    "STATISTICS": "Estadísticas",
    "WEBHOOKS": "Webhooks",
    "USERS": "Usuarios",
    "ADMIN_CONSOLE": "Admin Console",
    "TASKS": "Tareas",
    "ADMIN": "Admin",
    "GRAPHS": "Tableros",
    "HELP": "Asistente de ayuda",
    "HELP_CENTER": "Centro de Ayuda",
    "LOG_OUT": "Log out",
    "LOGGING_OUT": "Cerrando sesión de usuario...",
    "TEAMS": "Equipos",
    "LST_EMAILS": "Emails, separados por comas",
    "FIND_USERS": "Busque usuarios",
    "FIND_USERS_TAGS": "Busque usuarios y etiquetas",
    "FIND_TAGS": "Busque etiquetas",
    "SHOW_ALL": "Ver Todos",
    "LOADING": "Cargando...",
    "NO_AUTHORIZED": "No autorizado",
    "ACCEPT": "Aceptar",
    "OK": "OK",
    "CONTINUE": "Continuar",
    "SYNC": "Sincronizar",
    "GET_PARAMS": "Obtener parámetros",
    "REJECT": "Rechazar",
    "REJECTED": "Rechazado",
    "ADD": "Agregar",
    "CANCEL": "Cancelar",
    "CHOOSE": "Elegir",
    "ADVANCED": "Avanzado",
    "CLOSE": "Cerrar",
    "FINISH": "Finalizar",
    "CONFIG": "Configurar",
    "DELETE": "Eliminar",
    "CLEAR_DATE": "Limpiar fecha",
    "EDIT": "Editar",
    "COPY": "Copiar",
    "FIND": "Buscar",
    "FORMS": "Formularios",
    "RECORDS": "Registros",
    "NEXT": "Siguiente",
    "PREVIOUS": "Anterior",
    "REMOVE": "Remover",
    "SAVE": "Guardar",
    "SAVE_CLOSE": "Guardar y Cerrar",
    "INTEGRATIONS": "Integraciones",
    "SHEET": "Voolks Sheet",
    "KEY": "Clave",
    "VALUE": "Valor",
    "DASH_BUILDER": {
      "ADD_PAGE": "Agregar página",
      "EXPORT": "Exportar",
      "DESCRIP": "Descripción",
      "UPDATE_FOOTER": "Ocultar Barra Actualización Automática",
      "NAME": "Nombre",
      "AI_SCHEMA": {
        "BUTTON": "Esquema IA",
        "TITLE": "Esquema IA",
        "ENABLE": "Habilitar asistencia de carga por IA",
        "TERMS_REQUIRED": "Para poder habilitar el asistente se deben aceptar los términos y condiciones.",
        "PAGE": "Página {{n}}",
        "VALIDATOR_PAGE": "Validador · Página {{n}}",
        "EMPTY_PAGE": "Sin elementos",
        "EMPTY_FORM": "Este formulario no tiene páginas.",
        "TERMS_TITLE": "Términos y condiciones de AWS",
        "TERMS_SCROLL": "Desplazate hasta el final del texto para habilitar Aceptar. Si cancelás, la asistencia queda deshabilitada.",
        "TERMS_INTRO": "Para habilitar la asistencia de carga por IA hay que aceptar la normativa de Amazon Web Services que regula el uso de esos servicios. El texto vinculante es el publicado por AWS en los enlaces de esta ventana.",
        "TERMS_DOCS": "Normativa vigente de AWS",
        "TERMS_AGREEMENT": "Acuerdo del cliente de AWS",
        "TERMS_AGREEMENT_URL": "https://aws.amazon.com/es/agreement/",
        "TERMS_SERVICE": "Términos de servicio de AWS",
        "TERMS_SERVICE_URL": "https://aws.amazon.com/es/service-terms/",
        "TERMS_AUP": "Política de uso aceptable de AWS",
        "TERMS_AUP_URL": "https://aws.amazon.com/es/aup/",
        "TERMS_PRIVACY": "Aviso de privacidad de AWS",
        "TERMS_PRIVACY_URL": "https://aws.amazon.com/es/privacy/",
        "TERMS_P1": "La asistencia de carga utiliza servicios de inteligencia artificial provistos a través de AWS. Al aceptar, declarás que revisaste y aceptás el Acuerdo del cliente de AWS, los Términos de servicio de AWS y la Política de uso aceptable de AWS, en las versiones vigentes publicadas por Amazon Web Services.",
        "TERMS_P2": "El uso de la asistencia debe respetar esas condiciones. No está permitido un uso ilícito, abusivo o contrario a la política de uso aceptable. Quien habilita el asistente es responsable de los datos que se envían y de contar con las autorizaciones necesarias para tratarlos.",
        "TERMS_P3": "AWS puede procesar los datos enviados al asistente conforme a su normativa y a la configuración del servicio. La descripción cargada en cada elemento del formulario forma parte del esquema que el asistente usa para interpretar la carga.",
        "TERMS_P4": "AWS puede actualizar esos documentos. Si hay diferencia entre este resumen y el texto oficial, rige el texto publicado por AWS. Los enlaces abren la normativa completa en el sitio de Amazon Web Services.",
        "TERMS_P5": "La asistencia permanece deshabilitada hasta que se recorra este texto hasta el final y se presione Aceptar. Cancelar deja el asistente apagado y no registra la aceptación.",
        "TERMS_END": "Fin de la revisión. Al aceptar, confirmás que leíste la normativa de AWS indicada arriba y que aceptás aplicarla al uso de la asistencia de carga por IA en este formulario."
      },
      "MUST_SAVE": "Formulario nuevo, guardalo antes de acceder a configuraciones avanzadas",
      "CONFIGS": "Configuraciones",
      "OTHERS_CONFIG": "Otras Configuraciones",
      "OTHERS_CONFIG_BUTTON": "Otras",
      "EMAIL_CONFIG": "Configurar Envio Emails",
      "ACTION_CONFIG": "Configurar Acciones",
      "ACTION_CONFIG_BUTTON": "Acciones",
      "ACTION_CONFIGURED": "Acciones Configuradas :",
      "ACTION_CONFIGURED_NO": "No hay acciones configuradas",
      "ACTION_CONFIGUR_BUTTON": "CONFIGURAR",
      "REPORT_CONFIG": "Configurar Reporte",
      "REPORT_CONFIG_BUTTON": "Reporte",
      "REPORT_CONFIG_DEPT": "Reportes",
      "BEHAVIOR_CONFIG": "Configurar Comportamiento",
      "BEHAVIOR_CONFIG_BUTTON": "Comportamiento",
      "VALIDATE_TITLE": "Validaciones de Items",
      "VALIDATE_CONFIG": "Configurar Validacion",
      "VALIDATE_CONFIG_BUTTON": "Validaciones",
      "VALIDATE_REQUIRED": "Requiere Validacion",
      "VALIDATE_Q_REQUIRED": "Instancias Requeridas",
      "VALIDATE_TYPE": "Validadores",
      "VALIDATE_TYPE-DISTINCT": "distintos",
      "VALIDATE_TYPE-NOT_CONSECUTIVE": "no consecutivos",
      "VALIDATE_TYPE-INDISTINCT": "indistintos",
      "VALIDATE_TYPE-INSTANCE_DEFINED": "Definido por Instancia",
      "VALIDATE_USERS_SELECTION": "Indique a continuación los usuarios, supervisores o dueños, que pueden realizar la validacion. Para que sea cualquiera de ellos debe quedar vacio.",
      "VALIDATE_USERS_SELECTION_INSTANCE": "Indique a continuación los usuarios, supervisores, dueños y/o etiquetas, que pueden realizar la validación y certificación. Para que sea cualquiera de ellos debe quedar vacío.",
      "#1": "#1",
      "#2": "#2",
      "INPUT_VALIDATION": "Validación",
      "INPUT_CERTIFICACTION": "Certificación",
      "SELECT_IN_FIELD": "Seleccionado en Campo",
      "VALIDATE_NOTIFY": "Enviar email a validadores",
      "VALIDATE_EXPAND_MASK_USERS": "Expandir usuarios de máscaras",
      "VALIDATE_TEAMLEADER": "Valida Responsable de Equipo",
      "PAGE": "Página",
      "PAGE_WITHOUT_ELEMENTS": "Página sin elementos!",
      "ELEMENT_LOADING": "CARGANDO",
      "SAVE_OK_TOAST": "Configuración guardada",
      "DIAG_DEL_PAGE": {
        "TITLE": "Eliminar página",
        "BODY": "¿Desea eliminar esta página?.",
        "ACCEPT": "Eliminar página"
      },
      "DIAG_DEL_ELEMENT": {
        "TITLE": "Eliminar elemento",
        "BODY": "¿Desea eliminar este elemento?",
        "BODYWITHDATA": "El formulario ya tiene registros. SE PERDERAN LOS DATOS DEL ELEMENTO, ¿Esta seguro que desea eliminar esta elemento?.",
        "ACCEPT": "Eliminar elemento"
      },
      "ELEMENTS": {
        "DOCS": "Documentos",
        "VIDEOS": "Videos",
        "PHOTOS": "Fotos",
        "SIGN": "Firma",
        "AUTONUMERIC": "Autonumerar ",
        "TITLE": "Titulo",
        "GROUP": "Grupo",
        "SIMPLELIST": "Lista simple",
        "TEXT": "Texto",
        "SENDEMAIL": "Enviar Email",
        "SELECT": "Selección",
        "PIVOTCHART": "Pivot Chart",
        "GRID": "Grilla",
        "MAP": "Mapa",
        "DATASOURCE": "DataSource",
        "VALIDATE": "Validar online",
        "POPULATE": "Autocompletar",
        "CHECKBOX": "Checkbox",
        "MULTIPLE": "Múltiple",
        "GEO": "Geolocalización",
        "TIMESTAMP": "Timestamp",
        "DATE": "Fecha",
        "TIME": "Hora",
        "NUMBER": "Numero",
        "QR": "Lector QR",
        "FORMULA": "Fórmula",
        "DURATION": "Duración",
        "LINK_REPORT": "Vincular Reporte",
        "TEXT_VALIDATOR": "Texto Validador",
        "SELECT_VALIDATOR": "Selección Validador"
      },
      "CONFIG_DIR": {
        "TITLE": "Título",
        "AI_DESCRIPTION": "Descripción",
        "AI_DESCRIPTION_HELP": "Esta descripción se utilizará en Esquema IA",
        "MIN": "Valor Mínimo",
        "MAX": "Valor Máximo",
        "AUTO_SET": "Setear automáticamente al crear registro",
        "PRECISION15M": " Forzar a una precision 15m o mejor",
        "MIN_REQ_PRECISION": "Precisión Mínima Requerida",
        "AUTO_MOBILE": "Automática Móvil",
        "FORCEDECIMALES": "Forzar decimales",
        "THOUSANDSEPARATOR": "Separador miles",
        "BTNCOUNTER": "Botones para de/incrementar",
        "ALERT_ONLY": "Solo alerta",
        "MAXDECIMALSCOUNTINFO": "Limitar cantidad decimales",
        "VALUESCOUNTER": "paso para botones",
        "PLACEHOLDER": "Placeholder",
        "LIMIT_PHOTOS": "Cantidad de archivos",
        "BODYCAM": "Auditoría / BodyCam",
        "BODYCAM_INFO": "Único video de larga duración y fragmentado automático",
        "ALLOW_GALLERY": "Permitir archivos de galería",
        "VIDEO_MUTE": "Video sin sonido",
        "ALLOW_OLD_DATES": "Permitir fechas anteriores",
        "ALLOW_LATER_DATES": "Permitir fechas posterior",
        "MAX_OLD_DATES": "Máximo de dias hacia atrás",
        "MAX_LATER_DATES": "Máximo de dias hacia adelante",
        "ALLOW_OLD_TIMES": "Permitir horas anteriores",
        "PRELOAD_ITEMS": "Precargar Items",
        "MAX_OLD_TIMES": "Máximo de Horas hacia atrás",
        "ALLOW_LATER_TIMES": "Permitir horas posteriores",
        "MAX_LATER_TIMES": "Máximo de Horas hacia adelante",
        "SHOW_IF_CHECKBOX": "Mostrar si checkbox esta seleccionada:",
        "SHOW_IF_SELECT": "Mostrar si la opcion esta seleccionada:",
        "TEXTCOLOR": "Color de texto",
        "BACKGROUNDCOLOR": "Color de fondo",
        "WIDTH_APP": "Ancho (App)",
        "REQUIRED": "Obligatorio",
        "SORT": "Ordenar alfabéticamente",
        "USE_AS_TITLE": "Usar como título identificador del item",
        "TITLE_AS_COLS": "Título de items como columnas",
        "SHOW_FINDER": "Activar Buscador",
        "USE_WITH_FILTER": "Usar con Filtro de Busqueda",
        "GPS_STAMP": "Coordenadas GPS",
        "NOW_STAMP": "Fecha y Hora",
        "NO_MODAL": "Ver en misma pantalla",
        "OPTIONS_AS_BUTTONS": "Opciones como botones",
        "SIGN_FROM_PROFILE": "Permitir traer firma del perfil",
        "CLOSE_RECORD": "Cerrar Registro al completar",
        "ONLY_ONE": "Solo una opcion posible",
        "ROW_SPAN": "Lineas para escribir",
        "CONVERT_CASE": "Convertir ",
        "ALIGN": "Alinear",
        "NONE_CASE": "No cambiar",
        "UPPER_CASE": "Mayusculas",
        "LOWER_CASE": "Minusculas",
        "HREF": "Direccion Web(ejemplo https:///www.example.com/doc1.pdf)",
        "HINT": "Sugerencia",
        "HIDDEN": "Ocultar en app",
        "HIDDEN_LABEL": "Ocultar Etiqueta",
        "SL_MINRECORD": "Minimo registros requeridos",
        "READONLY": "Solo Lectura",
        "LASTVALUE": "Valor al que se le suma la cantidad de items",
        "ASSELECT": "Seleccionar respuesta",
        "Q_DECIMALS": "Cantidad de decimales",
        "ADD_SHOWCASE_LOGO": "Agregar logo",
        "ADD_SHOWCASE_LOGO_HINT": "Se redimensionará a un máximo de 80×80. Puede quedar más chico.",
        "ADD_SHOWCASE_IMAGE": "Agregar imagen",
        "ADD_SHOWCASE_IMAGE_HINT": "Se redimensionará a un máximo de 800×800. Puede quedar más chica.",
        "IMAGE_PROCESS_ERROR": "No se pudo procesar la imagen",
        "SHOWCASE_LOGO": "Logo",
        "SHOWCASE_IMAGE": "Imagen",
        "SHOWCASE_LOGO_PREVIEW": "Vista previa del logo",
        "SHOWCASE_IMAGE_PREVIEW": "Vista previa de la imagen"
      },
      "DURATION_DIR": {
        "DATECOMPARISION_TYPE": {
          "TITLE": "Tipo de comparacion:",
          "DATE": "Fechas",
          "TIME": "Horas",
          "TIMESTAMP": "Timestamps"
        },
        "START_ELEMENT": "Elemento de inicio",
        "END_ELEMENT": "Elemento de fin",
        "HIDDEN": "Ocultar en app:",
        "SAME_DAY": "Fin en el mismo dia que el inicio"
      },
      "FORM_FACTORY": {
        "SAVE_ERR_DEPTO": "Departamento incompatible",
        "SAVE_ERR_NAME": "Nombre requerido",
        "SAVE_ERR_NAME_DESC": "Nombre y descripción requeridos"
      },
      "FORMULA_DIR": {
        "ADVANCED": "Avanzado",
        "PLACEHOLDER": "ej: (2+a)*2/b",
        "VAR_COL": "Variable",
        "ELEM_COL": "Elemento",
        "VAL_COL": "Valor de prueba",
        "TOTAL": "Total",
        "RETURN": "Retorno",
        "Q_DECIMALS": "Cantidad decimales",
        "RETURN_DATA_TYPE": "Tipo de dato de Retorno"
      },
      "INTEGRATION_DIR": {
        "NO_AVAILABLE": "Este elemento no puede integrarse con ningún servicio.",
        "INFO_WS": "Para integrar el elemento con un web service, es necesario crear y configurar el mismo. En esta sección podrá configurar los aspectos dinamicos del mismo.",
        "SELECT_INT": "Seleccione integración a utilizar",
        "VIEW_INTEGRATION": "Ver Integración",
        "PARAMETERS": "Asigne elementos a los parametros dinámicos de la integración.",
        "GEO_DATA": "Datos de geo",
        "GEO_LAT": "latitud",
        "GEO_LNG": "longitud",
        "GEO_LATLNG": "latitud,longitud",
        "RETURN": "Asigne elementos a los datos devueltos por la integración.",
        "PARAM": "Parámetro",
        "FIELD": "Campo",
        "DEFAULT_VALUE": "Valor por defecto",
        "USER_MODE": "Sincronización a petición de usuario",
        "FORM": "Formulario",
        "VALIDATOR": "Validador",
        "PAGE": "Página"
      },
      "OPTIONS_DIR": {
        "HELP_MAIL": "Ingrese emails separados por coma. Si desea enviar el email al usuario que genero el item, escriba solamente la palabra reservada: \"user\" ",
        "HELP": "Ingrese valores separados por coma. Si el valor incluye una coma o espacios, ingrese todo el valor entre comillas. Ej: \"Lunes, martes y viernes \". Para poner un valor Default, debe agregar delante de la descripcion *|, ejemplo \"*|No Aplica\". Para activar otra opcion, y que se le active al usuario un campo de texto libre, escribir \"OTHER|\" y completar con la descripcion que se desee. Si requiere puntajes para las opciones a usar en el campo formula, debera separa el valor de la descripion con el caracter. | . Ejemplo: \"3|Opcion A\", \"5|Opcion C\". Debe tener limitado que solo permita elegir una opcion.",
        "COPY_ICON": "Click para copiar valores al portapapeles",
        "PASTE_ICON": "Click para pegar valores desde el portapapeles",
        "NEW_OPTION": "Ingrese valores",
        "REMOVE_ALL": "Remover todas las opciones",
        "ERR_CLIPBOARD_UNAVAILABLE_TITLE": "Error: Portapapeles no disponible",
        "ERR_CLIPBOARD_UNAVAILABLE_BODY": "El navegador no permite pegar desde el portapapeles en este entorno.",
        "ERR_PASTE_INVALID_TITLE": "Error: Formato inválido",
        "ERR_PASTE_INVALID_BODY": "El contenido pegado debe ser una lista de valores separados por coma. Si un valor incluye coma o espacios, enciérrelo entre comillas. Ej: \"Opción A\", \"3|Opción B\"",
        "ERR_PASTE_READ_FAILED_TITLE": "Error: No se pudo pegar",
        "ERR_PASTE_READ_FAILED_BODY": "No fue posible leer el portapapeles. Revise los permisos del navegador."
      },
      "OPTIONS_REF_COLOR": {
        "ERR_INVALID_REF_TITLE": "Error: Referencia inválida",
        "ERR_INVALID_REF_BODY": "La referencia no puede estar vacía.",
        "ERR_INVALID_COLOR_TITLE": "Error: Color inválido",
        "ERR_INVALID_COLOR_BODY": "El color debe tener formato hexadecimal (#FFFFFF).",
        "ERR_DUPLICATE_REF_TITLE": "Error: Referencia duplicada",
        "ERR_DUPLICATE_REF_BODY": "La referencia ingresada ya existe en la lista.",
        "ERR_CLIPBOARD_UNAVAILABLE_TITLE": "Error: Portapapeles no disponible",
        "ERR_CLIPBOARD_UNAVAILABLE_BODY": "El navegador no permite pegar desde el portapapeles en este entorno.",
        "ERR_PASTE_INVALID_JSON_TITLE": "Error: Formato inválido",
        "ERR_PASTE_INVALID_JSON_BODY": "El contenido del portapapeles no es válido.",
        "ERR_PASTE_INVALID_SHAPE_TITLE": "Error: Formato inválido",
        "ERR_PASTE_INVALID_SHAPE_BODY": "El contenido pegado debe ser un objeto JSON con formato referencia: color.",
        "ERR_PASTE_NO_VALID_TITLE": "Error: Sin datos válidos",
        "ERR_PASTE_NO_VALID_BODY": "No se encontraron referencias con colores válidos para pegar.",
        "ERR_PASTE_READ_FAILED_TITLE": "Error: No se pudo pegar",
        "ERR_PASTE_READ_FAILED_BODY": "No fue posible leer el portapapeles. Revise los permisos del navegador.",
        "ERR_MODAL_REFERENCE_REQUIRED": "Error: Ingrese una referencia válida.",
        "ERR_MODAL_COLOR_INVALID": "Error: Ingrese un color válido en formato hexadecimal (#FFFFFF).",
        "ERR_MODAL_DUPLICATE_REFERENCE": "La referencia ingresada ya existe en la lista."
      },
      "OPTIONS_ALT_DIR": {
        "HELP_RECIPIENTS": "Se pueden ingresar emails, números de whatsapp, o palabras reservadas. Ingrese emails separados por coma. Si desea enviar el email al usuario que generó el item, escriba solamente la palabra reservada: \"user\". Ingrese números de whatsapp con el siguiente formato: wa:5491155443322, en el que se inicia con \"wa:\", seguido de un número que contiene la característica del país, seguido del 9, el código de área y el número de teléfono.",
        "ERR_PASTE_INVALID_BODY": "El contenido pegado debe ser una lista de contactos separados por coma (emails, wa:+número, field:id, o palabras reservadas como user)."
      },
      "OPTIONS5_DIR": {
        "ERR_INVALID_TITLE": "Error: Parámetros inválidos",
        "ERR_INVALID_BODY": "Los siguientes valores no son válidos (solo texto sin espacios, letras, números, guión y guión bajo, deben comenzar con letra):",
        "ERR_INVALID_EDIT_BODY": "El valor editado no es válido. Debe ser texto sin espacios, comenzar con letra y usar solo letras, números, guión o guión bajo.",
        "ERR_DUPLICATE_TITLE": "Error: Parámetro duplicado",
        "ERR_DUPLICATE_BODY": "El parámetro ingresado ya existe en la lista."
      },
      "ELEMENT_DIR": {
        "ARCHIVED": "ARCHIVADO",
        "ARCHIVE_ELEMENT": "Archivar Elemento",
        "UNARCHIVE_ELEMENT": "Desarchivar Elemento",
        "DELETE_ELEMENT": "Borrar Elemento",
        "CLONE_ELEMENT": "Clonar Elemento"
      },
      "SIMPLELIST_DIR": {
        "TEXT": "Texto",
        "NUMBER": "Numero",
        "ADDFIELD": "Agregar nueva propiedad"
      },
      "ADVANCED_CONFIG": "Opciones Avanzadas",
      "CONDITIONS_GRAPH": {
        "NEW_RULE": "Nueva Regla",
        "CONDITION_ERROR": "Completar Condiciones",
        "INTEGRATION_NO_AND_OR": "En integraciones solo se pueden agregar reglas. AND y OR no se aplican.",
        "AND": "AND",
        "OR": "OR",
        "NESTED_RULES_MIN": "Debe tener al menos dos reglas anidadas",
        "ITEM_VALIDATION": "Validación del item",
        "ALL": "Todos",
        "FIELD": "Elemento",
        "VALUE": "Valor",
        "VALUE_PLACEHOLDER": "Valor a comparar",
        "VALUE_PLACEHOLDER_LIST": "Valores separados por coma",
        "OPERATORS": {
          "EQUAL": "igual a",
          "DISTINT": "distinto de",
          "LESS": "menor a",
          "GREATER": " mayor que",
          "LESS_EQUAL": "menor igual",
          "GREATER_EQUAL": " mayor igual a",
          "EXISTS": "existe",
          "NOT_EXISTS": "no existe",
          "STARTS_WITH": "empieza con",
          "ENDS_WITH": "termina con",
          "CONTAINS": "contiene",
          "IN": "está en",
          "NOT_IN": "no está en",
          "BETWEEN": "entre",
          "REGEXP": "expresión regular",
          "IGNORE": "ignorar"
        }
      },
      "ERROR_CONDITIONS": {
        "TITLE": "Error: Campos incompletos",
        "MESSAGE": "Debe completar todos los campos de cada condición."
      },
      "GROUP_CONDITIONS": {
        "INFO": "Esta sección permite asignar opciones dinámicas al campo de grupo, según las respuestas de otros campos.",
        "ADD": "Nueva condición",
        "PILL_CONDITION": "Condiciones aplicadas"
      },
      "DINAMIC_SELECT": {
        "INFO": "Esta sección permite asignar opciones dinámicas al campo de selección, según las respuestas de otros campos.",
        "ADD": "Nueva condición"
      },
      "SELECT_OPTIONS": {
        "MAKE_DINAMIC": "Cambiar a Modalidad con Elección de Reglas",
        "OPTIONS_DATA": "Definir las opciones en funcion de los valores de los datos de campos:",
        "OPTIONS_STATIC": "Definir las opciones independientemente de los datos de campos:"
      },
      "DATASOURCE": {
        "OPTIONS": "Opciones",
        "FORM": "Formulario",
        "ACTION": "Acción",
        "INTEGRATION": "Integración",
        "CONCATENATE": "Concatenar DS",
        "RELATION": "Vincular DS",
        "LEFT_RELATION": "Asociar DS Secundario",
        "DS1": "DS 1",
        "DS2": "DS 2",
        "DS1_PRIMARY": "DS 1 (Primario)",
        "DS2_SECONDARY": "DS 2 (Secundario)",
        "RESULTING_FIELDS": "Campos Resultantes",
        "CONCATENATE_DESCRIPTION": "DataSources a Unir Verticalmente (Coincidencia de Nombre de Columna)",
        "FORM_DESCRIPTION": "Formulario",
        "ACTION_DESCRIPTION": "Acción",
        "ACTION_FILTERS_INFO": "Condiciones por las que se filtran las respuestas de la acción:",
        "FORM_FILTERS_INFO": "Condiciones por las que se filtran los items del formulario:",
        "INTEGRATION_FILTERS_INFO": "Condiciones por las que se filtran los items de la integración:",
        "ACTION_FILTER_CREATED_AT": "Creado (createdAt)",
        "ACTION_FILTER_SYSTEM": "Sistema",
        "ACTION_FILTER_METADATA": "Metadatos",
        "ACTION_FILTER_RESPONSE": "Parámetros de respuesta",
        "NO_ACTION_RESPONSE_PARAMS": "No tiene columnas definidas",
        "NO_ACTION_WEBHOOKS": "El formulario no tiene acciones webhook definidas",
        "INTEGRATION_DESCRIPTION": "Integración",
        "ADDITIONAL_COLUMNS": "COLUMNAS ADICIONALES",
        "NEW_COLUMN_TITLE": "Titulo de nueva columna",
        "NEW_COLUMN_CONTENT_FORMULA_1": "Formula contenido. Ejemplo row['precio'] * 2",
        "NEW_COLUMN_CONTENT_FORMULA_2": "Formula contenido. Para cantidad de SubItems: idcampo.subItemsCount",
        "ADD_COLUMN": "Agregar Columna",
        "ADDITIONAL_REPROCESS_SCRIPT": "Script de reproceso adicional",
        "FILTERS": "Filtros",
        "ELEMENT": "Elemento",
        "FORM_FIELDS": "Campos del Formulario",
        "CONFIGURATION": "CONFIGURACION",
        "ONLY_LAST_VERSION": "Traer Solo ultima version de la columna(default ID)",
        "RESULTSET": "ResultSet",
        "DATASOURCE": "DataSource",
        "DATASOURCE_OPTIONS": "Origen de Datos",
        "DATASOURCE_FIELD": "Campos DataSource",
        "ERROR_DS_PRE": "Se deben completar los siguientes campos:",
        "ERROR_DS_TITLE": "Error: Campos incompletos",
        "CLIC_COPY_CLIPBOARD": "Clic para copiar al clipboard"
      },
      "WORKFLOW_CONFIG": {
        "INTRO_LINE1": "A continuacion podras configurar una serie de pasos donde se require la participacion de distintos usuarios para completar este mismo formulario. Es decir es el workflow de carga del formulario, si lo que quiere definir es un workflow del dato producido debe ir a Acciones y Reportes",
        "INTRO_LINE2": "Cada paso tendra de referencia un elemento checkbox que es el que se activara automaticamente al momento de realizarse el delivery al usuario siguiente. Este checkbox activara la seccion siguiente que se debe encontrar dentro de un grupo asociado al checkbox. N grupos pueden asociarse a ese checkbox y no necesariamente deben estar en un orden de ubicacion.",
        "BEHAVIOR": "Comportamiento",
        "DIGITAL_CERTIFICATION": "Certificación Digital",
        "WORKFLOW": "Workflow",
        "PTW": "Permiso de Trabajo",
        "INSTANCE_1": "Instancia 1:",
        "INSTANCE": "Instancia",
        "IDENTIFICATION": "Identificación",
        "PTW_STEP_DEFINITIONS": ">Definiciones",
        "PTW_STEP_ENABLES": ">Habilita",
        "PTW_STEP_CLOSURE": ">Cierre",
        "INITIAL_ACCESS_INFO": "El acceso inicial sera dado por cualquier usuario suscripto al formulario, a menos que internamente se defina en el formulario alguna condicion.",
        "CREATED_BY_USER": "Usuario Creador",
        "CREATED_BY_USER_TOOLTIP": "Elemento Texto configurado como solo lectura donde automaticamente escribirá el usuario creador de la solicitud: Miguel Garcia <mgarcia@example.com>",
        "DOCUMENT_DATE": "Fecha Documento",
        "DOCUMENT_DATE_TOOLTIP": "Para indica la fecha en que se va a emplear el documento para el caso de actividades programadas. Si se deje vacio se toma la fecha de creación del registro",
        "ENABLES_WORK": "Habilita trabajo",
        "LOCKS_EDITABLE_FIELDS": "Bloquea Campos editables",
        "CHECKBOX_ACTIVATES_FIELDS": "Checkbox que activa campos",
        "CHECKBOX_ACTIVATES_FIELDS_TOOLTIP": "Debe ser un elemento checkbox que este oculto al movil, y que habilite mediante grupo, los elementos que le corresponden a la instancia",
        "RESPONSIBLE_USER": "Usuario Responsable",
        "RESPONSIBLE_USER_TOOLTIP": "Debe ser un elemento seleccion que tenga como valor de la opcion el id o los ids, separados por coma: '65d8919dbbf829705c7f66a0|Miguel Garcia'",
        "ADD_INSTANCE": "AGREGAR INSTANCIA",
        "GLOBAL": "Global",
        "SCROLL_TO_STEP": "Posicionar automáticamente donde esta checkbox que activa instancia.",
        "LOCK_SAME_USER": "Bloquea la interaccion de un mismo usuario",
        "LOCATION": "Ubicacion",
        "LOCATION_TOOLTIP": "Campo geolocalizacion o en texto siguiendo el formato latitud,longitud,por ejemplo: -39.0133, -69.5619",
        "REJECT_CHECK": "Check para rechazar",
        "FILTER_IDLE_DAYS": "Filtrar por Días de Inactividad",
        "REJECT_AUTOMATICALLY": "Rechazar Automáticamente",
        "REJECT_IDLE_DAYS": "Rechazo Automático por Días de Inactividad",
        "ALLOW_REJECT_ANY_STEP": "Permitir rechazar en cualquier instancia",
        "MEMBER_TYPE_LABEL": "Responsables identificador por:",
        "MEMBER_TYPE_EMAIL": "Email",
        "MEMBER_TYPE_USER_ID": "Id de Usuario",
        "EDITABLE_FIELDS": "Campos editables",
        "EDITABLE_FIELDS_PTW_SUFFIX": "antes de la instancia marcada por \"Habilita Trabajo\"",
        "ANY_INSTANCE": "En cualquier instancia",
        "PAGE": "Página",
        "MEASUREMENT": {
          "TITLE": "Certificación Digital",
          "ID": "Id",
          "COMPANY": "Empresa/Contratista",
          "ASSET": "Activo (Asset)",
          "AGREEMENT": "Contrato/Acuerdo/Convenio",
          "TYPE": "Tipo",
          "POINTS_LIST": "Lista Simple donde estan los Puntos de Medicion",
          "ITEM_TO_REJECT": "Registro de Punto Anterior a Rechazar",
          "POINT_ID": "Campo identificador del item dentro de la lista",
          "DATE": "Fecha",
          "SECTION": "Sector",
          "FILTER_1": "Filtro 1",
          "FILTER_2": "Filtro 2",
          "FILTER_3": "Filtro 3"
        }
      }
    },
    "DASH_ADMIN": {
      "TITLE": "Consola de Administracion",
      "TENANTS_REGISTRADOS": "Tenants registrados",
      "TENANT": "Tenant",
      "MEMBERS": "Miembros",
      "ITEMS": "Items",
      "LASTITEMDATE": "Ultimo item creado",
      "DISABLED": "Deshabilitado",
      "DELETE": "Borrar",
      "DIAG_DEL_TENANT": {
        "TITLE": "Eliminar tenant",
        "BODY": "¿Desea eliminar al tenant {{tenantId}}. Por favor asegurese de lo que esta haciendo."
      }
    },
    "CLIENTS": {
      "TITLE": "Administre sus sitios",
      "NEW": "Nuevo sitio",
      "REMOVE": "Borrar Sitios seleccionados",
      "EDIT": "Editar sitio",
      "NO_RECS": "La cuenta no posee ningún sitio. Por favor cree nuevos.",
      "INFO": "El módulo de Sitios está directamente relacionado con el módulo de Tareas, y solo es necesario poblarlo con datos de Sitios en el caso en que se quieran administrar las tareas de los usuarios desde la plataforma Field.",
      "COLS": {
        "ASSOCIATED": "Asociado a",
        "NAME": "Nombre",
        "ADDRESS": "Dirección",
        "EMAIL": "Email",
        "PHONE": "Telefono",
        "DETAIL": "Detalle",
        "DETAIL_INFO": "Piso, departamento, etc",
        "LNG": "Longitud",
        "LAT": "Latitud",
        "IMPORTED": "Importado",
        "IMPORTED_ACRONYM": "Imp.",
        "OU": "Unidad Organizativa",
        "OU_ACRONYM": "U.O.",
        "OWNERS": "Administradores del Sitio"
      },
      "DIAG": {
        "TITLE": "Eliminar Sitio",
        "BODY": "¿Desea eliminar el sitio {{clientName}}?"
      },
      "DIAGMULTIPLE": {
        "TITLE": "Eliminar Sitios",
        "BODY": "¿Desea eliminar los sitios seleccionados?"
      },
      "IMPORT": {
        "ERROR_SITE_DATA": "Error en los datos del sitio. Verifique que la Dirección o las Coordenadas (Latitud y Longitud) estén completas."
      }
    },
    "DATA": {
      "TITLE": "Datos",
      "TITLE_INFO": "La columna Demora(hs), representa el tiempo transcurrido entre la creación del formulario y el envío al servidor expresado en horas.",
      "VIEWMAP": "Ver mapa",
      "VIEWTASK": "Ver tareas",
      "ACTIONS": "Acciones",
      "MORE_ACTIONS": "Ver más acciones",
      "DOWNLOAD": "Descargar",
      "EXPORT_CSV": "Exportar a CSV",
      "EXPORT_XLSX": "Exportar a XLSX",
      "DOWNLOAD_PDF": "Descargar PDF",
      "DEL_SEL": "Eliminar seleccionados",
      "VIEW_ARCHIVED": "Ver campos archivados",
      "HIDE_ARCHIVED": "Ocultar campos archivados",
      "RESET_FILTERS": "Reiniciar Filtros",
      "RESET_GRID_LAYOUT": "Reiniciar Columnas",
      "REFRESH_TABLE": "Actualizar tabla",
      "ERROR_DATE": "Debe ingresar una fecha con formato YYYY-MM-DD",
      "COLS": {
        "USER": "Usuario",
        "STARTED_AT": "Creado",
        "CREATED_AT": "Subido",
        "CLOSED_REC": "Cerrado",
        "DELAY": "Demora subida(hs)",
        "DELAY_TOOLTIP": "Tiempo transcurrido entre la creación del formulario y el envío al servidor expresado en horas.",
        "LAST_STEP": "Última Instancia",
        "NAME": "Nombre tarea",
        "SITE": "Sitio tarea",
        "DESCRIP": "Descripción tarea"
      },
      "ACTION_PROCESSED": "Acción Procesada",
      "PROCESS_ACTIONS": "Ejecutar Acciones",
      "NO_ACTION_SELECTED": "No hay acciones seleccionadas",
      "REPORT_PROCESSED": "Reporte Procesado",
      "PROCESS_REPORTS": "Ejecutar Reportes",
      "NO_REPORT_SELECTED": "No hay reportes seleccionados"
    },
    "DASH_DEPT": {
      "NO_FORMS": "El departamento no cuenta con ningun formulario. Por favor cree uno.",
      "NO_TEAM": "El departamento no cuenta con ningun equipo.",
      "PLANIFICAR_TAREAS": "Planificar tareas",
      "DAY_TASKS": "Tareas del día",
      "ADMIN_DEPTO": "Administre su departamento",
      "TAG_SYNC_ADMIN_DEPTO": "Importar Supervisores",
      "TAG_SYNC_ADMIN_DEPTO_TOOLTIP": "Importar supervisor y tags asociados desde Google Sheets",
      "TAG_SYNC_ADMIN_DEPTO_INFO": "Importar supervisor y tags asociados desde Google Sheets, dandose automáticamente el rol al usuario (cuenta de correo) en el departamento  \"deptName\", y las altas/bajas de tags que asocian a los usuarios.",
      "TAG_SYNC_ADMIN_DEPTO_EXAMPLE": "Podes encontrar los datos en:",
      "TAG_SYNC_WARNING": "¿Está seguro de que desea continuar? Al realizar este proceso se puede eliminar información importante.",
      "TAG_SYNC_IMPORT_SUCCESS": "Sincronización exitosa: se asignaron supervisores y actualizaron etiquetas según lo definido en el Google Sheet.",
      "ADD_OWNER": "Agregar dueño",
      "ADD_SUPERVISOR": "Agregar Supervisor",
      "ADD_OWNER_TEAM": "Agregar dueños al equipo",
      "ADD_USER_TAGS": "Etiquetas",
      "TAGS_SYNC": "Sincronizar Etiquetas",
      "INFO_USERS_OWNER": "Busque los usuarios que desea incorporar como dueños",
      "ADD_USER": "Agregar usuarios",
      "ADD_SUPERVISOR_TEAM": "Agregar supervisores al equipo",
      "NO_TAGS_DEPT": "El departamento no posee etiquetas",
      "NO_TAGS_DEPT_USER": "El departamento no posee etiquetas para asignarle al usuario",
      "NO_TAGS_CHIP": "Todas las etiquetas han sido asignadas",
      "ERROR_TAG_USER_ASSIGN": "Error al asignar etiqueta al usuario",
      "ERROR_TAG_USER_UNLINK": "Error al eliminar etiqueta del usuario",
      "ERROR_TAG_DEPT_NEW": "No se pudo crear la etiqueta",
      "ERROR_TAG_DEPT_MODIFY": "No se pudo modificar la etiqueta",
      "INFO_USER_SUP": "Busque los usuarios que desea incorporar como supervisores",
      "ADMIN": {
        "TITLE": "Dueños de {{deptoName}}",
        "USERS": "Usuarios",
        "INFO": "Los dueños de departamentos pueden crear formularios y equipos y asignar tareas",
        "NO_DEPTO_OWNER": "{{deptoName}} no cuenta con ningun dueño.",
        "INFO_2": "El dueño de un Departamento tiene permiso para dar de alta usuarios, formularios, equipos, sitios y tareas. No tiene permiso para dar de alta otros Departamentos. Es por eso que a un Dueño de Departamento lo tiene que dar de alta el Administrador, es decir, el primer usuario que registro la Cuenta empresa en Field. El Administrador, puede definir más de un Dueño de un Departamento y a su vez puede darle role de Administrador a otros usuarios. El Supervisor de un Departamento solo tiene permiso para ver y bajar datos y reportes.",
        "TAGS_MULTI": "Etiquetas Multiples",
        "COLS": {
          "NAME": "Nombre",
          "EMAIL": "Email",
          "PRIVILEGES": "Privilegios",
          "SUPERVISOR": "Supervisor",
          "OWNER": "Dueño",
          "TAGS": "Etiquetas"
        },
        "DIAG_DEL": {
          "TITLE": "Eliminar dueño",
          "BODY": "¿Desea eliminar al usuario {{ firstName }} {{ lastName }} como dueño y/o supervisor del grupo? No podrá administrar/supervisar el departamento ni ver sus datos."
        }
      },
      "DEPT_TAG": {
        "TITLE": "Etiquetas del Departamento",
        "ADD_TAG": "Nueva Etiqueta",
        "EDIT_TAG": "Editar Etiqueta",
        "DIAG_DEL": {
          "TITLE": "Eliminar etiqueta",
          "BODY": "Al eliminar la etiqueta, se eliminará de todos los elementos a los que esté asociada."
        }
      }
    },
    "DASH_DEPTS": {
      "NEW": "Nuevo Departamento",
      "TITLE": "Administre sus departamentos",
      "LABEL_NEW": "Ingrese el nombre del nuevo departamento",
      "INFO_1": "La cuenta no posee ningun departamento. Por favor cree uno.",
      "INFO_2": "Para que un usuario (usuario de campo; de la aplicación móvil) pueda comenzar a usar la aplicación, debe haber sido primero asignado a un departamento. Y para que un Departamento sea habilitado, es necesario asignarle un dueño. Por eso, la creación de usuarios es una de las primeras tareas que hay que realizar luego de la registración de la cuenta en Field. Obviamente, el usuario que se Registró en Field ya es usuario y por lo tanto, para usar la app móvil solo tiene que crear un Departamento, darse de alta como Dueño del mismo, crear un equipo de trabajo y suscribir ese equipo al Formulario creado.",
      "COLS": {
        "NAME": "Nombre",
        "FORMS": "Formularios",
        "MEMBERS": "Miembros",
        "ADMIN": "Administrar Departamento",
        "DELETE": "Eliminar Departamento"
      },
      "DIAG_DEL": {
        "TITLE": "Eliminar departamento",
        "BODY": "Al eliminar el departamento se eliminara toda la información relacionada al mismo."
      }
    },
    "DASH_GRAPH": {
      "DIAG_COPY": {
        "TITLE": "Copiar tablero",
        "QUESTION": "¿Desea crear una copia del tablero?",
        "LABEL": "Departamento destino:",
        "ACCEPT": "Copiar tablero",
        "ACTION_TYPE": "Modo de copiado",
        "NEW": "Generar un nuevo Formulario",
        "OVERWRITE": "Sobreescribir destino con origen",
        "UPDATE": "Agregar campos nuevos, y archivar inexistentes",
        "FORM_TO": "Formulario Destino",
        "INFO": "Cambios en ubicaciones/configuraciones de los campos seran sobreescritas del origen al destino",
        "ICON_ARCHIVED": "Elemento archivado",
        "ICON_ADD": "Campo que se agregara en el destino",
        "ICON_DELETE": "Campo que será eliminado",
        "ICON_ARCHIVE": "Campo no existente en origen y que pasara a archivarse al final de la pagina"
      },
      "NEW": "Nuevo tablero",
      "COPY_TEXT": "Copia de ",
      "IMPORT": "Importar tablero",
      "NOT_FOUND": "No se encontró el tablero",
      "NO_INFO": "El departamento no cuenta con ningun tablero. Por favor cree uno.",
      "DIAG_CREATE": {
        "TITLE": "Nuevo tablero",
        "BODY": "¿Desea crear un tablero?"
      },
      "TOOLTIP_SUBS": "No hay equipos subscriptos a este tablero",
      "TOOLTIP_EDIT": "Editar Tablero",
      "TOOLTIP_USERS": "Usuarios",
      "TOOLTIP_DATA": "Datos",
      "TOOLTIP_RPT": "Configuración del reporte",
      "TOOLTIP_CP": "Copiar",
      "TOOLTIP_API": "API url(beta)",
      "TOOLTIP_WH": "Subscribir a webhook",
      "DIAG_DEL": {
        "TITLE": "Eliminar tablero",
        "BODY": "Al eliminar el tablero no tendra más acceso a los datos generados por el mismo."
      },
      "DIAG_IMPORT": {
        "TITLE": "Importar Tablero",
        "GRAPH_NAME": "Nombre del tablero",
        "SELECT": "Seleccionar Archivo",
        "ACCEPT": "Importar",
        "FILE_VALID": "Error al leer archivo JSON. Asegúrese de que el archivo tenga un formato válido.",
        "FILE_WITHOUT_GRAPH": "El archivo ingresado no posee tablero (graph)",
        "MISSING_DS": "Debe completar todos los campos de formulario e integraciones",
        "NO_NAME": "El tablero no tiene nombre",
        "PAGE_WITHOUT_ELEMENTS": "Página {{page}} sin elementos",
        "CREATE_FAILED": "Error al crear el tablero",
        "CREATE_NO_ID": "El tablero se creó pero no se recibió un identificador válido",
        "OPEN_FAILED": "El tablero se importó pero no se pudo abrir"
      },
      "DIAG_EXPORT": {
        "TITLE": "Exportar",
        "BODY": "Se guardarán los cambios realizados en el tablero.<br><br><strong>Advertencia:</strong> Si desea importar este Tablero en otro Departamento, debe asegurarse de exportar los Formularios e Integraciones utilizados en el mismo e importarlos en el Departamento correspondiente.",
        "ACCEPT": "Continuar"
      },
      "REFERENCE_COLORS": "Colores de referencias",
      "REFERENCE_COLORS_INFO": "Defina los colores asociados a las referencias utilizadas en los gráficos del tablero.",
      "AXIS_SCALE": "Tipo de escala",
      "AXIS_SCALE_AUTO": "Automática",
      "AXIS_SCALE_LINEAR": "Lineal",
      "AXIS_SCALE_LOG": "Logarítmica",
      "AXIS_SCALE_DATE": "Fecha",
      "AXIS_SCALE_CATEGORY": "Categoría",
      "AXIS_SCALE_LOG_HINT": "La escala logarítmica no muestra valores menores o iguales a cero.",
      "AXIS_Y": "Eje Y",
      "AXIS_X": "Eje X",
      "AXIS_TITLE": "Título",
      "TICK_FORMAT": "Formato de valores",
      "TICK_AUTO": "Automático",
      "TICK_INTEGER": "Enteros",
      "TICK_DECIMAL": "Decimales",
      "TICK_CURRENCY": "Moneda",
      "TICK_PERCENT": "Porcentaje",
      "TICK_MONTH_YEAR": "Mes / Año",
      "TICK_YEAR": "Año",
      "TICK_MONTH": "Mes",
      "AXIS_MIN": "Mínimo",
      "AXIS_MAX": "Máximo",
      "DATA_SET": "Conjunto de datos",
      "DATA_ORDER_TOP": "Primeros",
      "DATA_ORDER_LAST": "Últimos",
      "DATA_QUANTITY": "Cantidad",
      "PANEL_BACKGROUND": "Color fondo panel",
      "HIDE_TITLE_BAR": "Ocultar barra título",
      "SIZE_WIDTH": "Ancho",
      "SIZE_HEIGHT": "Altura",
      "SIZE_FRACTION": "Fracción",
      "SIZE_PERCENTAGE": "Porcentaje",
      "SIZE_PERCENTAGE_PLACEHOLDER": "Porcentaje (0-100)",
      "LOGO_POSITION": "Posición logo",
      "TEXT_ALIGN": "Alineación texto",
      "GRID": {
        "RESET_FILTERS_TOOLTIP": "Reiniciar Filtros",
        "RESET_COLUMNS_TOOLTIP": "Reiniciar Columnas",
        "VIEW_MODE_TOOLTIP": "Modo Visualización",
        "EDIT_MODE_TOOLTIP": "Modo Edición",
        "REFRESH_TOOLTIP": "Actualizar Gráfico",
        "DOCS_FILTER_WITH": "Con Docs",
        "DOCS_FILTER_WITHOUT": "Sin Docs"
      }
    },
    "DASH_FORM": {
      "TEAMS": {
        "TITLE": "Equipos",
        "TITLE_1": "Subscriba equipos al formulario",
        "NO_INFO": "El departamento no cuenta con ningun equipo.",
        "NO_INFO_1": "Por favor cree uno en la sección de equipos.",
        "COLS": {
          "NAME": "Nombre",
          "DESCRIP": "Descripción",
          "MEMBERS": "# miembros",
          "STATE": "Estado"
        },
        "ADD_TEAM": "Equipo subscripto",
        "ADD_TEAM_ERR": "Error al subcribir equipo",
        "REMOVE_TEAM": "Equipo desubscripto",
        "REMOVE_TEAM_ERR": "Error al desubcribir equipo"
      },
      "DIAG_QR": {
        "QR_READ": "Leyendo este QR desde móvil, tendrás acceso directo al formulario"
      },
      "DIAG_COPY": {
        "TITLE": "Copiar formulario",
        "QUESTION": "¿Desea crear una copia del formulario?",
        "LABEL": "Departamento destino:",
        "ACCEPT": "Copiar formulario",
        "ACTION_TYPE": "Modo de copiado",
        "NEW": "Generar un nuevo Formulario",
        "OVERWRITE": "Sobreescribir destino con origen",
        "UPDATE": "Agregar campos nuevos, y archivar inexistentes",
        "FORM_TO": "Formulario Destino",
        "INFO": "Cambios en ubicaciones/configuraciones de los campos seran sobreescritas del origen al destino",
        "ICON_ARCHIVED": "Elemento archivado",
        "ICON_ADD": "Campo que se agregara en el destino",
        "ICON_DELETE": "Campo que será eliminado",
        "ICON_ARCHIVE": "Campo no existente en origen y que pasara a archivarse al final de la pagina"
      },
      "NEW": "Nuevo Formulario",
      "IMPORT": "Importar Formulario",
      "EXPORT": "Exportar",
      "NO_INFO": "El departamento no cuenta con ningun formulario. Por favor cree uno.",
      "DIAG_CREATE": {
        "TITLE": "Nuevo formulario",
        "BODY": "¿Desea crear un formulario?"
      },
      "DIAG_IMPORT": {
        "TITLE": "Importar Formulario",
        "FORM_NAME": "Nombre del formulario",
        "SELECT": "Seleccionar Archivo",
        "ACCEPT": "Importar",
        "FILE_VALID": "Debe ingresar un archivo válido",
        "FILE_WITHOUT_FORM": "El archivo ingresado no posee formulario (form)",
        "REVIEW": {
          "TITLE": "Revisá antes de importar",
          "INTRO": "El formulario se crea igual. Esto queda pendiente en este tenant:",
          "USERS": "Hay {{count}} validadores elegidos por usuario en el origen. Hay que volver a asignarlos.",
          "TAGS": "La validación depende de etiquetas del origen. Esas etiquetas tienen que existir en este tenant.",
          "EXTERNAL": "Estas integraciones siguen apuntando a archivos o servicios del origen: {{names}}.",
          "SHEETS": "Estas integraciones leen planillas internas del origen, que acá no existen: {{names}}.",
          "GOOGLE": "Estas integraciones leen un Google Sheet externo: {{names}}.",
          "NO_URL": "Estas integraciones vienen sin dirección. Revisalas después de importar: {{names}}.",
          "LOGO": "El logo del reporte es un archivo del origen y puede no verse.",
          "GRAPH": "Está vinculado a un tablero que no viene en el archivo.",
          "TEAMS": "Los equipos no se importan. Hay que volver a suscribir el formulario."
        },
        "INTEGRATIONS_TITLE": "Integraciones",
        "INTEGRATIONS_HELP": "Si ya existe en este tenant, elegila. Si no, se puede crear una nueva.",
        "INTEGRATION_REUSE_ID": "Ya existe en este tenant y se va a reutilizar.",
        "INTEGRATION_CREATE": "Crear nueva",
        "INTEGRATIONS_LOADING": "Todavía se están cargando las integraciones de este tenant.",
        "MISSING_INTEGRATION": "Elegí una integración existente o crear una nueva para {{name}}.",
        "SUMMARY_TITLE": "Integraciones del formulario",
        "SUMMARY_CREATED": "Se crearon: {{names}}.",
        "SUMMARY_REUSED": "Se reutilizaron: {{names}}.",
        "NO_NAME": "El formulario no tiene nombre",
        "PAGE_WITHOUT_ELEMENTS": "Página {{page}} sin elementos",
        "INTEGRATION_ID_MISMATCH": "El ID de integración {{id}} en el formulario no coincide con ninguna integración en el archivo.",
        "INTEGRATION_CREATE_ERROR": "Error al crear la integración: {{message}}",
        "IMPORT_ERROR": "Error al importar el formulario"
      },
      "DIAG_EXPORT": {
        "TITLE": "Exportar",
        "BODY": "Se guardarán los cambios realizados en el formulario.",
        "ACCEPT": "Continuar"
      },
      "TOOLTIP_SUBS": "No hay equipos subscriptos a este formulario",
      "TOOLTIP_EDIT": "Editar Formulario",
      "TOOLTIP_USERS": "Usuarios",
      "TOOLTIP_DATA": "Datos",
      "TOOLTIP_RPT": "Configuración del reporte",
      "TOOLTIP_CP": "Copiar",
      "TOOLTIP_API": "API url(beta)",
      "TOOLTIP_WH": "Subscribir a webhook",
      "SHOW_ARCHIVED": "Ver Archivados",
      "ARCHIVE_FORM": "Archivar formulario",
      "UNARCHIVE_FORM": "Desarchivar formulario",
      "DIAG_DEL": {
        "TITLE": "Eliminar formulario",
        "BODY": "Al eliminar el formulario no tendra más acceso a los datos generados por el mismo."
      },
      "REPORT": {
        "SIGN_DOCUMENT": "Documento con firma electronica",
        "BLOCKCHAIN_CERTIFICATE": "Certificar transacción en blockchain",
        "TITLE": "Configuración del reporte",
        "TITLE_DEPT": "Configurar Plantilla de Reporte del Departamento",
        "SHOW_FIELDS": "Campos a mostrar",
        "DEPT_REPORT_CONFIG": "Aplicar Plantilla",
        "SEL_LOGO": "Seleccione un logo",
        "LOGO": "Logo",
        "LOGO_CONFIG": "Configurar Logo",
        "HAS_IMAGE": "Tiene imagen",
        "NO_IMAGE": "Sin imagen",
        "IMAGE_NOT_FOUND": "No se encontró la imagen",
        "LOGO_URL": "URL LOGO",
        "COPY_URL": "Copiar URL",
        "URL_COPIED": "URL copiada",
        "URL_COPY_ERROR": "No se pudo copiar la URL",
        "WATERMARK": "Marca de agua",
        "WATERMARK_CONFIG": "Configurar Marca de agua",
        "WATERMARK_IMAGE": "Seleccione una imagen",
        "WATERMARK_POSITION": "Posición",
        "WATERMARK_SIZE": "Tamaño",
        "WATERMARK_OPACITY": "Opacidad",
        "WATERMARK_PREVIEW": "Vista previa",
        "NUMBER_COLSGRID": "Presentar en Columnas",
        "SHOW_TITLE": "Mostrar título",
        "UPPER_LABELS": "Forzar Mayúsculas",
        "UNDERLINE": "Linea Separadora",
        "DRAW_ASTABLE": "Dibujar como Tabla",
        "HIDE_LABEL": "Ocultar etiqueta",
        "IN_NEW_PAGE": "En página nueva",
        "SHOWCASE": "Imprimir Showcase",
        "SHOWCASE_IMG": "Imagen Altura Máxima",
        "SL_HIDEHEADERS": "Ocultar",
        "TEXTALIGN": "Alinear campo",
        "HIDE": "Ocultar",
        "TAB_VALUES": "Valores tabulados",
        "PRINT_HEADERFOOTER": "Imprimir Header(Department-FormName-Date-UserName) y Footer(NroPage)",
        "SHOW_AS_ATTACHED": "Mapas y Fotos como anexos al final del reporte",
        "VALUE_AS_ATTACHED": "Mostrar como anexo",
        "COLSPAN": "Expandir columnas",
        "ROWSPAN": "Expandir Filas",
        "ROTATE_LABEL": "Rotar Cabecera",
        "ROTATED_HEIGHT": "Alto",
        "COLSPAN_INFO": "según columnas de reporte",
        "MAXHEIGHTPHOTOINFORM": "Altura máxima de las fotos/Mapas en formulario(cm)",
        "GEO_TIMESTAMP": "Mostrar Fecha Hora de la Geolocalización",
        "GEO_PRECISION": "Mostrar precisión de la Geolocalización",
        "SHOWAS_QR": "Mostrar como QR",
        "QR_SIZE": "Tamaño del QR",
        "QR_SHOWVALUE": "Mostrar Valor",
        "INTERLINE": "Interlineado",
        "CSS_TITLE": "Seteos Avanzados CSS",
        "CSS_CELL": "CSS CELDA",
        "CSS_LABEL": "CSS ETIQUETA",
        "CSS_VALUE": "CSS VALOR",
        "SHOW_DESCRIP": "Mostrar descripción",
        "SHOW_DATE": "Mostrar fecha y hora del reporte",
        "SHOW_INSPECTOR": "Mostrar nombre inspector",
        "BOLD_TITLE": "Etiquetas en negrita",
        "SHOW_MAP": "Mostrar mapa en campo geoposicionamiento",
        "SHOW_MAP_SAT": "Mostrar mapa en modo satelital",
        "COLSXROWS": "Invertir columnas por filas en Lista simple",
        "VALIDATE_REQUIRED": "Mostrar Validaciones",
        "PAGE_SIZE": "Tamaño Papel",
        "PAGE_SIZE_LETTER": "Carta",
        "PAGE_ORIENTATION": "Orientacion Papel",
        "PAGE_ORIENTATION_1": "Apaisada",
        "PAGE_ORIENTATION_2": "Normal",
        "FONT_SIZE": "Tamaño de la tipografía",
        "FONT_SIZE_O1": "Chico",
        "FONT_SIZE_O2": "Mediano",
        "FONT_SIZE_O3": "Grande",
        "Q_PHOTOS": "Cantidad de fotos por fila",
        "FORMAT_RPT": "Formato del reporte",
        "FORMAT_RPT_O1": "Predeterminado",
        "FORMAT_RPT_O2": "Dos columnas",
        "FORMAT_RPT_O3": "Personalizado",
        "AUTO_SEND": "Envio de Reportes Automaticos",
        "CONDITIONAL_EMAILS": "Avanzado",
        "ACTIONS_SEND": "Acciones",
        "EMAIL_INFO_1": "Para enviar al usuario que subio el registro ingresar ",
        "EMAIL_INFO_2": ", será reemplazado con su correo de usuario",
        "WA_INFO_1": "o si desea ponerle una etiqueta",
        "WA_INFO_2": "receptor1",
        "EMAIL_KEY_USER": "user",
        "INFO_1": "A continuacion usted podra configurar una lista de emails. Aquellas direcciones que usted configure recibiran un email cada vez que se cargue algun elemento a la base de datos, con el reporte en PDF correspondiente adjunto.",
        "INFO_2": "A continuacion usted podra configurar una lista de emails dependiendo de los valores que se cargan en el formulario. Aquellas direcciones que usted configure recibiran un email cada vez que se cargue algun elemento a la base de datos, con el reporte en PDF correspondiente adjunto.",
        "LBL_SAVEINFO": "Tiene cambios sin guardar.",
        "LBL_CONFIG_OK": "Configuración guardada",
        "LBL_LOGO_OK": "Archivo Cargado",
        "SEL_FIELDS": "Seleccionar campos",
        "SEL_FIELDS_INFO": "Arrastre hacia la columna derecha los campos a mostrar en el reporte",
        "SEL_FIELDS_ADD_ALL": "Pasar todos",
        "SEL_FIELDS_REMOVE_ALL": "Eliminar todos",
        "ADD_ALL_DIALOG": {
          "TITLE": "Pasar todos los campos",
          "BODY": "Ya tiene campos en la columna derecha. Al pasar todos, la lista se reordenará según el orden del formulario y se perderá el orden personalizado actual. ¿Desea continuar?"
        },
        "DEPT_REPORT_DIALOG": {
          "TITLE": "Reporte: Plantilla",
          "BODY": "Se reemplazará la configuración actual con la configuración de plantilla del departamento",
          "BODY2": "La configuración de reporte de los formularios preexistentes no se modificará automáticamente. Los cambios deberán realizarse manualmente."
        },
        "INSERT_VALUE": {
          "BODY": "Cabecera Tabla (HTML)",
          "FOOTER": "Pie de Tabla (HTML)",
          "BODY_PLACEHOLDER": "Mensaje predeterminado",
          "EMPTY_SPACE": "Valor para campos vacíos",
          "TABLE_LAYOUT": "Página como Tabla"
        }
      },
      "ACTIONS": {
        "ACTIONS_TITLE": "ACCIONES",
        "INFO_1": {
          "INFO_1": "Esta funcionalidad permite extender el ",
          "INFO_2": "flujo de trabajo hacia elementos externos ",
          "INFO_3": "al formulario. Estas ",
          "INFO_4": "ACCIONES ",
          "INFO_5": "pueden ser el envío de un ",
          "INFO_6": "reporte vía correo electrónico",
          "INFO_7": ", una notificación por ",
          "INFO_8": "WhatsApp",
          "INFO_9": ", la creación de ",
          "INFO_10": "nuevas tareas ",
          "INFO_11": "dentro de Field conectando a otros usuarios y/o formularios, o la integración con ",
          "INFO_12": "sistemas externos ",
          "INFO_13": "mediante Webhooks, como ser la creación de un evento en un sistema de tickets.",
          "INFO_14": "La ejecución de estas Acciones puede establecerse según un origen (nuevo, validación, eliminación de registros) y/o según se cumplan condiciones en los datos relevados en el formulario."
        },
        "INFO_2": {
          "INFO_1": "No tiene acciones definidas",
          "INFO_2": "Cada acción se construye con 3 pasos: Un disparador o trigger, condiciones o filtros, y finalmente la acción a realizar.",
          "INFO_3": "Disparador: ",
          "INFO_4": "Son eventos sobre los registros que inician el proceso de evaluación de la acción o workflow.",
          "INFO_5": "Condiciones: ",
          "INFO_6": "Permiten determinar cuándo continuar con el flujo de trabajo, según los valores del registro. Puede crear filtros seleccionando un campo con el operador y valor correspondientes, combinar condiciones mediante operadores lógicos and y or.",
          "INFO_7": "Acciones: ",
          "INFO_8": "El paso final del workflow, donde se indica qué es lo que debe realizarse con el registro de datos."
        },
        "INFO_REPORT": {
          "INFO_1": "Envio de Reporte automático",
          "INFO_2": "A continuacion usted podra configurar una lista de emails. Aquellas direcciones que usted configure recibiran un email cada vez que se cargue algun elemento a la base de datos, con el reporte en PDF correspondiente adjunto."
        },
        "INFO_ACTIONS": "A continuacion usted podrá configurar una lista de acciones que se ejecutarán en función de las operaciones que se realicen con los formularios.",
        "ACTION_TITLE": "Acción N°",
        "ERROR_FIELDS_TITLE": "Error: Formulario incompleto",
        "ERROR_ACTIONS_PRE": "Se encontraron los siguientes errores:",
        "ERROR_REQUIRED_FIELD": "es un campo requerido.",
        "ERROR_REQUIRED_CONDITIONS": "deben completarse todos los campos de las condiciones agregadas.",
        "FIELDS": {
          "NAME": "Nombre",
          "DESCRIP": "Descripción",
          "INIT_WHEN": "1. Iniciar cuando hay:",
          "DATA_MATCH": "2. Y los datos coincidan con:",
          "ACTION_TODO": "3. Hacer la siguiente acción:",
          "ACTION_EMAIL": {
            "SUBJECT": "Asunto / Mensaje",
            "SUBJECT_TOOLTIP": "Asunto de Email y/o mensaje de Whatsapp",
            "SUBJECT_PLACEHOLDER": "Asunto predeterminado",
            "BODY": "Cuerpo del mensaje (Email)",
            "BODY_PLACEHOLDER": "Mensaje predeterminado",
            "EMPTY_VALUE": "Valor para campos vacíos",
            "EMPTY_VALUE_PLACEHOLDER": "Ej: **",
            "EMPTY_VALUE_TOOLTIP": "Texto que se muestra en el cuerpo del mensaje cuando un campo insertado no tiene valor.",
            "LOAD_HTML_EDITOR": "Cargar Editor HTML",
            "REPORT": "Reporte",
            "RECIPIENTS": "Destinatarios",
            "INSERT_VALUE": "Insertar valor dinámico del Formulario"
          },
          "ACTION_WEBHOOK": {
            "ACTIONREPEATSIMPLELIST": "Repetir accion por cada fila de la lista ",
            "ACTIONREPEATNUMBER": "Si asocio lista simple, aca informa el numero de repetición para invocar a fila respectiva",
            "TITLE_H3": "Referencia al registro ingresado",
            "_CREATEDAT": "Fecha y hora en que se subió al servidor. Formato DateTime UTC String.",
            "_STARTEDAT": "Fecha y hora en que se inició el registro. Formato DateTime UTC String.",
            "CLOSEDAT": "Fecha y hora de cierre del registro. Formato DateTime UTC String.",
            "OTHER_ATTRIBUTES": "Otros atributos con valores específicos.",
            "PHONEINFORMATION": "Objeto que contiene información del teléfono.",
            "VALIDATE": "Arreglo de objetos con las instancias de validación realizadas por el supervisor.",
            "MEMBER": "Objeto que representa al usuario que cargó el registro.",
            "FORM": "Objeto que describe el formulario.",
            "FORM.NAME": "Nombre del formulario.",
            "FORM.ID": "Identificador del formulario.",
            "FORM.OTHER_ATTRIBUTES": "Otros atributos relacionados con el formulario.",
            "PAYLOAD": "Objeto que contiene los datos recolectados en el formulario por el operador.",
            "PAYLOAD_DESCRIPTION": "Se cada uno se accede a través del id del campo y comparten los siguientes atributos:",
            "PAYLOAD.ID": "Identificador del elemento.",
            "PAYLOAD.TYPE": "Tipo de elemento (select, number, populate, text).",
            "PAYLOAD.NAME": "Nombre del elemento.",
            "PAYLOAD.VALUE": "Valor del elemento.",
            "PAYLOAD.PAGE": "Número de página asociado al elemento.",
            "PAYLOAD_FIELDS": "Los identificadores para los campos son:",
            "RESPONSE_PARAMS": "Parámetros de respuesta",
            "RESPONSE_PARAMS_PLACEHOLDER": "Ej: status, ticketId",
            "RESPONSE_PARAMS_HELP": "Nombres de parámetros que retorna el webhook. Solo texto sin espacios (letras, números, guión y guión bajo). Separados por coma."
          },
          "ACTION_CERTIFY_PDF": {
            "CONTACT_SUPPORT": "Por favor, póngase en contacto con el equipo de Soporte Field para definir su Wallet y Contrato."
          },
          "FILTERS": "Filtros"
        },
        "TRIGGER_LIST": {
          "NEW_RECORD": "Nuevo Registro",
          "VALIDATE": "Validación OK / Rechazada",
          "VALIDATE_OK": "Validacion OK",
          "VALIDATE_REJECT": "Validación Rechazada",
          "DEL_RECORD": "Eliminación de un Registro"
        },
        "ACTIONS_LIST": {
          "EMAIL": "Envío de Reportes (Emails/WhatsApp)",
          "WEBHOOK": "Activación de WebHook",
          "CERTIFY_PDF": "Certificar Transacción en Blockchain",
          "TASK": "Generación de Tarea (Solicita completar formulario)"
        },
        "REPORT_LIST": {
          "NONE": "No enviar",
          "PDF_ATTACHMENT": "Predeterminado PDF adjunto",
          "HTML_ATTACHMENT": "Predeterminado HTML adjunto",
          "HTML_EMBEDDED": "Predeterminado HTML en el cuerpo del mensaje"
        },
        "DELETE_ACTION": "Eliminar Acción",
        "ADD_ACTION": "Nueva Acción",
        "CLONE_ACTION": "Clonar Acción",
        "DISABLE_ACTION": "Inhabilitar acción",
        "ENABLE_ACTION": "Habilitar acción",
        "STATE_ACTIVE": "Activo",
        "STATE_INACTIVE": "Inactivo",
        "ERROR_CONVERT_TITLE": "Conversión de datos",
        "ERROR_CONVERT_BODY": "Las Condiciones del formulario se han convertido en Acciones. Edite y acepte los cambios para guardarlos."
      },
      "OTHERS_CONFIG": {
        "ELEMENT_TYPE": "Tipo de elemento",
        "CHANGE_TYPE": "Cambiar Tipo a",
        "PRESET": "Predefinir",
        "HIDE_GRID_TITLE": "Visibilidad en Grillas",
        "HIDE_GRID": "Ocultar Elemento",
        "WITHOUT_REVISION": "No requiere Revisión de usuario",
        "METADATA": "METADATOS",
        "METADATA_INFO": "Informacion asociada al formulario requerida al momento de consumir el API o WebHook (Clave-Valor)"
      }
    },
    "DASH_INTEG": {
      "SAVE": "Guardar Integración",
      "EXPORT": "Exportar Integración",
      "IMPORT": "Importar Integración",
      "ASSOCIATED_FORMS": "Formularios Asociados",
      "NO_ASSOCIATED_FORMS": "No posee formularios asociados.",
      "ASSOCIATED_FORMS_ERROR": "No se pudieron cargar los formularios asociados.",
      "FORM_INTEGRATIONS_TITLE": "Integraciones usadas en el formulario",
      "FORM_VALIDATE_INTEGRATIONS_TITLE": "Integraciones usadas en validación del formulario",
      "NO_FORM_INTEGRATIONS": "Este formulario no está utilizando integraciones.",
      "FORM_INTEGRATIONS_ERROR": "No se pudieron cargar las integraciones del formulario.",
      "INTEGRATION_DELETED": "Integración eliminada",
      "INTEGRATION_DELETED_LABEL": "ELIMINADO",
      "OPEN_ALL": "Abrir todas las Integraciones",
      "SAVE_FIRST": "Debes grabar primero la integración",
      "URL_TAB_CHANGE_CONFIRM_TITLE": "Cambiar tipo de conexión",
      "URL_TAB_CHANGE_CONFIRM_MESSAGE": "Al cambiar el tipo de conexión se borrará toda la configuración de la integración (URL, parámetros, autenticación, datos de respuesta, etc.). ¿Desea continuar?",
      "GLOBAL": "Global",
      "FIELDS": {
        "DEPT": "Departmaneto Asociado",
        "SITE": "Sitio Asociado",
        "URL_TYPE": {
          "FORM": "Formulario de Field",
          "VOOLKS_SHEET": "Voolks Sheet",
          "S3": "Field S3",
          "GOOGLE": "Google Sheet",
          "STANDARD": "Estandar",
          "AI": "IA"
        },
        "AI": {
          "MODEL": "Modelo",
          "MODEL_LITE": "Análisis de documentos y formularios",
          "MODEL_PRO": "Imágenes y formas geométricas",
          "PROMPT": "Prompt",
          "PROMPT_PLACEHOLDER": "Prompt de la conexión",
          "ONLY_POPULATE": "Solo tipo de integración Autocompletar",
          "TYPE_HELP": "Para IA solo se puede usar Autocompletar.",
          "DYNAMIC_PARAMS_HELP": "Estos campos son asociados a un elemento en el formulario y usaran los datos ingresados en el mismo. Para IA se espera alguno de estos parámetros: base64Data, mediaType, mimeType.",
          "POPULATE_DESCRIPTION": "Descripción"
        },
        "VOOLKS_SHEET_MODE": {
          "SIMPLE": "Simple",
          "ADVANCED": "Avanzado"
        },
        "GOOGLE": {
          "ERROR": "No se pudo acceder a la información. Revise credenciales y permisos del archivo.",
          "ASSISTANT": "Asistente",
          "SHEET_ID": "ID de Google Sheet:",
          "SHEET_NAME": "Nombre de hoja (SheetName):",
          "LOAD_BOOK_SHEETS": "Cargar hojas del libro",
          "SELECT_BOOK_SHEET": "Seleccionar hoja",
          "GET_SHEET_COLUMNS": "Obtener columnas de la hoja",
          "GET_COLUMNS": "Obtener columnas",
          "VALUE_LABEL_TOOLTIP": "Nombre con el que se expone el valor al formulario y columna del sheet.",
          "FIRST_VALUE_IS_TITLE": "Primer valor es titulo",
          "SIMPLE_LIST": "Lista simple",
          "SORT_ALPHABETICALLY": "Ordenar alfabeticamente",
          "LIST": "Lista",
          "ID_PARSE_ERROR": "No se pudo obtener el ID de Google Sheet desde la URL.",
          "LOAD_SHEETS_FIRST": "Primero obten las hojas desde el botón de recarga.",
          "SHEETS_LOADED": "Nombres de hojas cargadas correctamente.",
          "COLUMNS_LOADED": "Columnas cargadas correctamente."
        },
        "STANDARD": {
          "URL_PLACEHOLDER": "http://127.0.0.1/webservice/misdatos, dejar vacío si no es necesario descargar informacion",
          "UPLOAD_FILE": "SUBIR ARCHIVO",
          "UPLOAD_FILE_FIRST_SAVE": "Si deseas subir un archivo, primero debes crear la integración y luego se habilitará la carga.",
          "UPLOADING_FILE": "Cargando archivo..."
        },
        "VOOLKS_SHEET": {
          "BOOK_NAME": "Nombre del libro:",
          "OPEN_BOOK_TOOLTIP": "Abrir libro en Voolks Sheet",
          "SELECT_BOOK": "Seleccione un libro",
          "SHEET": "Hoja:",
          "SELECT_SHEET": "Seleccione una hoja",
          "IMPORTANT_INFO": "Aviso: Recuerda que el tiempo de sincronización entre la hoja y las integraciones es de 5 minutos tras el último cambio."
        },
        "S3": {
          "TABLE_NAME": "Nombre de tabla",
          "SEPARATOR": "Separador",
          "DATA_TYPE": "Tipo de datos",
          "PRIMARY_KEY": "Clave primaria",
          "INDEX": "Indice",
          "COLUMN_ALREADY_EXISTS": "La columna ya existe",
          "TYPE_INTEGER": "INTEGER",
          "TYPE_REAL": "REAL",
          "TYPE_TEXT": "TEXT"
        },
        "EDITOR": {
          "DATA": "Data",
          "PARAMS": "Params",
          "PARAMS_TITLE": "PARAMS:",
          "SAVE_CHANGES_HINT": "Debes grabar los cambios para que se vean reflejados.",
          "FORMAT_DOCUMENT": "Format Document",
          "RETURN_VALUE": "Return Value"
        },
        "AUTH": {
          "TITLE": "Autorización ",
          "TYPE": "Tipo Autenticacion",
          "ACCESSKEY": "Access Key",
          "SECRETKEY": "Secret Key",
          "REGION": "Region",
          "SERVICE": "Servicio",
          "OPTION_NONE_PUBLIC": "NONE | Sin Autenticacion | Publico",
          "OPTION_USER_TOKEN": "Voolks UserToken",
          "OPTION_AWS_SIGNATURE": "AWS Signature",
          "OPTION_MSAL": "Microsoft Authentication Library",
          "OPTION_GOOGLE_APIS": "Google Cloud Platform (GoogleApis)",
          "GOOGLE_HELP_1": "Si deseas usar la cuenta de servicio de Field, agrega permisos al usuario: fieldapi@fieldglobal.iam.gserviceaccount.com y deja en blanco el campo de credenciales.",
          "GOOGLE_HELP_2": "Si deseas crear tu propio usuario de servicio, aqui se encuentra la referencia con los pasos a seguir:",
          "GOOGLE_OAUTH_LINK_LABEL": "OAUTH GOOGLE",
          "GOOGLE_HELP_3": "Luego pega el contenido del archivo JSON resultante en el campo siguiente.",
          "CREDENTIALS_JSON_CONTENT": "CONTENIDO JSON DE CREDENCIALES",
          "CLIENT_ID": "Client Id",
          "TENANT_ID": "Tenant Id",
          "CLIENT_SECRET": "Client Secret"
        },
        "PARAM_URL": "Si los parametros deben asignarse ala URL, deben estar encerrados entre barras /Parametro1/. El nombre de los parametros es arbitrario y debe ser único en la URL.<br> Ejemplo<br><b>URL</b>:https://www.miapp.com/cat/<i>categoriaNumero</i>/prod/<i>numeroproducto</i>?order=descrip<br> <b>Parametros</b><ul><li>/categoriaNumero/</li><li>/numeroproducto/</li></ul><br> Ejemplo 2<br><b>URL</b>https://graph.microsoft.com/v1.0/users?$count=true&$search=\"displayName:<i>{displayName}</i>\"&$orderBy=displayName&$select=displayName,mail<br> <b>Parametros</b><ul><li>{displayName}</li></ul>",
        "DATA": "Datos básicos",
        "TYPE": "Tipo de integración",
        "TYPE_GET": "Traer datos",
        "TYPE_VALIDATE": "Validar",
        "TYPE_AUTO": "Autocompletar",
        "NAME": "Nombre",
        "DESCRIP": "Descripción",
        "CONFIG": "Configurar conexión",
        "URL": "URL",
        "COPY_URL": "Copiar URL",
        "COPY_URL_OK": "URL copiada",
        "COPY_URL_ERROR": "No se pudo copiar la URL",
        "FORM_FILTER": {
          "UPLOADED": "Subido",
          "CREATED": "Creado",
          "CLOSED": "Cerrado",
          "FORM": "Formulario",
          "PAGE": "Página",
          "LAST_VALIDATION": "Última Validación",
          "VALIDATION_DATE": "Fecha de Validación",
          "VALIDATION_STATE": "Estado de Validación",
          "VALIDATION_FROM": "Validación Desde",
          "VALIDATION_UNTIL": "Validación Hasta",
          "VALIDATOR": "Validador",
          "APPROVED": "Aprobado",
          "REJECTED": "Rechazado",
          "NOT_PENDING": "Aprobado/Rechazado",
          "PENDING": "Pendiente"
        },
        "SELECT_OPTION_GLOBAL": "GLOBAL",
        "FORMAT_REQUEST": "Formato de datos Request",
        "FORMAT": "Formato de datos Response",
        "METHOD_GET": "GET",
        "METHOD_POST": "POST",
        "FORMAT_REQUEST_DATA": "DATA",
        "FORMAT_REQUEST_JSON_BODY": "JSON BODY",
        "FORMAT_JSON": "JSON",
        "FORMAT_XML": "XML",
        "FORMAT_TEXT": "TEXT",
        "FORMAT_ARRAY": "ARRAY",
        "METHOD": "Método",
        "ROWS": "Cantidad de Registros",
        "ALLOW_OFFLINE": "Cachear para uso Desconectado",
        "ALLOW_OFFLINE_TOOLTIP": "Descarga los datos de la URL al momento de sincronizar la app. Los parámetros que envía son solamente los estáticos, y la autorización la obtiene en ese momento.",
        "REFRESH_OFFLINE": "No sincronizar antes de transcurrir ",
        "REFRESH_OFFLINE_TOOLTIP": "No vuelve a descargar la información de la web antes de que hayan transcurrido las horas indicadas. Para forzar el plazo el usuario debe desloguearse de la app y volver a entrar. Si se pone CERO solamente se descargará al momento del login",
        "ADDPARAMS": "Agrega parametros al header",
        "PH_DEFAULT": "Valor por defecto",
        "PH_HEADER": "Header",
        "PH_VALUE": "Valor",
        "PH_ACTIVE": "activo",
        "PH_OP": "Operación",
        "PH_FIELD": "Columna",
        "PARAM": "Parametro",
        "PARAM_NAME_REQUIRED": "Indique un nombre para el parametro.",
        "PARAM_COLUMN_SHEET": "Valores devueltos",
        "PARAM_STATIC": "Parametros estaticos",
        "PARAM_STATIC_TOOLTIP": "Estos campos son definidos desde esta interfaz. En el caso de usar palabras claves, seran reemplazadas por el valor correspondiente: {currentUser.email} , {currentUser}",
        "PARAM_DYNAMIC": "Parametros dinámicos",
        "PARAM_DYNAMIC_TOOLTIP": "Estos campos son asociados a un elemento en el formulario y usaran los datos ingresados en el mismo.",
        "VALS_AUTO": "Valores devueltos por autocomplete",
        "TT_VALS_AUTO": "Ingrese los campos devueltos por el web service con los cuales desea completar elementos del formulario.",
        "AFTERHOOK": "AfterHook",
        "AFTERHOOK_I1": "Esta función se ejecuta luego de realizado el request al web service. De esta manera es posible modificar los datos y adaptarlos a la estructura requerida por la integración y su uso en los formularios.",
        "AFTERHOOK_I2": "La misma tiene un tiempo máximo de ejecución de 10ms y recibe como primer argumento los datos devueltos por el request y como segundo los parametros dinamicos enviados.",
        "AFTERHOOK_I3": "La función debe devolver(return) obligatoriamente el formato correcto(array, boolean o un objeto javascript con una estructura definida).",
        "AFTERHOOK_I4": "Si el request espera un string XML, el mismo sera convertido a un objeto JS antes de pasarlo a la función.",
        "AFTERHOOK_LIBRARY_TITLE": "Libreria de funciones",
        "AFTERHOOK_LIBRARY_FIND_FIELD": "Obtiene el elemento dentro del registro, util para cuando se obtienen otros registros generados en FIELD.",
        "AFTERHOOK_LIBRARY_GSHEET_LIST": "Retorna la lista de datos de una columna para integraciones de Google Sheet.",
        "AFTERHOOK_LIBRARY_CSV_TABLE": "Retorna una tabla para procesar para integraciones de un archivo CSV.",
        "AFTERHOOK_LIBRARY_CSV_LIST": "Retorna la lista de datos de una columna para integraciones de un archivo CSV.",
        "AFTERHOOK_LIBRARY_GPS_DISTANCE": "Calculo de distancias, retorna los KMs entre dos coordenadas de GPS."
      },
      "MODALS": {
        "EXAMPLE": {
          "FIND_DATA": "Podes encontrar los datos en:"
        },
        "GOOGLE_ASSISTANT": {
          "TITLE": "Obtener parametros desde URL",
          "URL_PLACEHOLDER": "https://sheets.googleapis.com/v4/spreadsheets/... o https://docs.google.com/spreadsheets/d/..."
        },
        "GOOGLE_SHEET_NAMES": {
          "SELECT_SHEET": "Seleccionar hoja",
          "AVAILABLE_SHEETS": "Hojas disponibles"
        },
        "S3": {
          "SQLITE_CONNECTION_DESC": "Conexión al SQLite con los datos del SFTP recibido en la tabla \"data\".",
          "MOBILE_ONLY_DESC": "Solo visible desde el movil. Requiere un archivo recibido en el SFTP.",
          "USAGE_EXAMPLE": "Ejemplo de uso:",
          "NOTE_LABEL": "Nota:",
          "NOTE_TEXT": "Esta funcionalidad está diseñada para trabajar con grandes volumenes de datos en dispositivos móviles."
        },
        "DATA_ERROR": {
          "RESPONSE_API": "RESPONSE API"
        },
        "DATA_SUCCESS": {
          "RETURN_VALUES": "RETURN VALUES:"
        }
      },
      "TITLE": "Administre sus integraciones",
      "NEW": "Nueva integración",
      "COPY_TEXT": "Copia de ",
      "TITLE_1": "Integraciones",
      "NO_INFO": "La no cuenta con ninguna integración. Por favor cree nuevas.",
      "INFO_1": "El modulo de Integraciones permite obtener datos en tiempo real al completar un formulario desde distintos servicios web.",
      "INFO_2": "Algunos ejemplos de lo que permiten las integraciones:",
      "INFO_2_LI1": "Actualizar campos de selección con valores cargados desde un servidor externo.",
      "INFO_2_LI2": "Enviar coordenadas y autocompletar una dirección fisica.",
      "INFO_2_LI3": "Validar si un sitio está al día con los pagos, una garantía es válida o si hay stock de un producto.",
      "INFO_3": "Las integraciones soportan requests GET y POST",
      "INFO_TOGGLE_ARIA": "Mostrar u ocultar la información sobre integraciones",
      "INFO_TOGGLE_TOOLTIP": "Pulse para mostrar u ocultar la descripción de integraciones",
      "COLS": {
        "NAME": "Nombre",
        "DESCRIP": "Descripción",
        "TYPE": "Tipo",
        "SITE": "Sitio",
        "DEPT": "Departamento",
        "CONNECTION_TYPE": "Tipo de Conexión",
        "OFFLINE": "Offline",
        "CREATED_BY": "Creado por",
        "CREATED_AT": "Creado",
        "UPDATED_BY": "Modificado por",
        "UPDATED_AT": "Modificado"
      },
      "DIAG_DEL": {
        "TITLE": "Eliminar integración",
        "BODY": "¿Está seguro de que desea eliminar la integración <strong>{{name}}</strong>?",
        "IN_USE": "La integración <strong>{{name}}</strong> está siendo utilizada en los formularios:"
      },
      "DIAG_IMPORT": {
        "TITLE": "Importar Integración",
        "INTEG_NAME": "Nombre del Integración",
        "SELECT": "Seleccionar Archivo",
        "ACCEPT": "Importar",
        "FILE_VALID": "Error al leer archivo JSON. Asegúrese de que el archivo tenga un formato válido.",
        "FILE_VALID_2": "Seleccione un archivo válido.",
        "NO_NAME_INTEG": "Debe ingresar un nombre para la integración.",
        "CREATE_FAILED": "No se pudo importar la integración",
        "CREATE_NO_ID": "La integración se creó pero no se recibió un identificador válido"
      }
    },
    "DASH_SHEETS": {
      "TITLE": "Administre sus Archivos de Datos",
      "IMPORT": "Importar Archivo",
      "NEW": "Nuevo Archivo",
      "TITLE_1": "Archivos",
      "REFRESH_FILES": "Actualizar Archivos",
      "NO_INFO": "No cuenta con ningún archivo de datos. Por favor cree nuevos.",
      "INFO_1": "Gestione listas maestras de datasets para usar en los formularios.",
      "COLS": {
        "NAME": "Nombre",
        "SITE": "Sitio",
        "DEPARTMENT": "Departamento"
      },
      "DIAG_DEL": {
        "TITLE": "Eliminar archivo",
        "BODY": "¿Desea eliminar el archivo {{name}}?"
      },
      "NEW_SHEET_PLACEHOLDER": "Funcionalidad de nueva archivo en desarrollo",
      "OPEN_SHEET_PLACEHOLDER": "Funcionalidad de abrir archivo en desarrollo: {{name}}",
      "DELETED_SUCCESS": "Archivo eliminado correctamente",
      "CREATED_SUCCESS": "Archivo creado correctamente",
      "UPDATED_SUCCESS": "Archivo actualizado correctamente",
      "ERROR_CREATE": "No se pudo crear el archivo",
      "ERROR_UPDATE": "No se pudo actualizar el archivo",
      "ERROR_DELETE": "No se pudo eliminar el archivo",
      "MODAL": {
        "TITLE": "Nuevo Archivo",
        "TITLE_EDIT": "Editar Archivo",
        "NAME": "Nombre",
        "NAME_PLACEHOLDER": "Ingrese el nombre del archivo",
        "NAME_REQUIRED": "El nombre es obligatorio",
        "SITE": "Sitio",
        "SITE_REQUIRED": "El sitio es obligatorio",
        "DEPARTMENT": "Departamento",
        "SELECT_DEPARTMENT": "Seleccione un departamento",
        "DEPARTMENT_REQUIRED": "El departamento es obligatorio",
        "GLOBAL": "Global",
        "VALIDATION_ERROR": "Por favor complete todos los campos obligatorios"
      }
    },
    "STATS": {
      "FILTER": "Filtrar por fecha de carga",
      "CHK_AVERAGE": "Agrupado por Mes",
      "FILTER_BUTTON": "Filtrar",
      "REFRESH_BUTTON": "Recargar",
      "FROM_FILTER": "Desde",
      "UNTIL_FILTER": "Hasta",
      "NO_ITEMS": "No tenés validaciones pendientes asignadas a tu usuario",
      "TITLE": "ITEMS RELEVADOS",
      "TITLE_1": "Distribución de items relevados por periodo",
      "INFO1": "Se grafican los primeros 10 usuarios de los Registros detallados, deberá modificar los filtros o el ordenamiento para ajustar a la información deseada.",
      "TITLE_2": "Demora en envio de datos al servidor(hs)",
      "INFO2_1": "Se grafican los primeros 10 usuarios de los Registros detallados, deberá modificar los filtros o el ordenamiento para ajustar a la información deseada.",
      "INFO2_2": "Tiempo transcurrido entre la creación del formulario y el envío al servidor expresado en horas.",
      "TITLE_3": "Proporción de items relevados por miembro",
      "INFO3": "Se grafican los primeros 10 usuarios de los Registros detallados, deberá modificar los filtros o el ordenamiento para ajustar a la información deseada.",
      "INFO5": "Se grafican los primeros 10 departamentos y 10 formularios de los Registros detallados, deberá modificar los filtros o el ordenamiento para ajustar a la información deseada.",
      "TITLE_4": "Registros detallados",
      "TITLE_5": "Proporción de items relevados por Departamento y formulario",
      "INFO4": "Items creados agrupados por miembro y sus totales. La columna Demora(hs), representa el tiempo transcurrido entre la creación del formulario y el envío al servidor expresado en horas.",
      "DOWNLOAD": "Exportar grilla a CSV",
      "DOWNLOAD_XLSX": "Exportar grilla a XLSX",
      "NOTIFICATION": "Enviar Notificacion",
      "DELETE_USERS": "Borrar Usuarios",
      "COLS": {
        "DELAY": "Demora(hs)",
        "DELAY_TOOLTIP": "Tiempo transcurrido entre la creación del formulario y el envío al servidor expresado en horas.",
        "DEPARTMENT": "Departamento",
        "EMAIL": "Email",
        "FORM": "Formulario",
        "ITEMS": "Items",
        "LAST_ITEM": "Ultimo Item",
        "MEMBER": "Miembro",
        "PERIOD": "Periodo",
        "TOTAL": "\"Total \""
      },
      "TITLEVALIDATIONS": "VALIDACIONES",
      "TITLEVALIDATIONS_1": "Validaciones de Registros por Formularios",
      "TITLEVALIDATIONS_2": "Validaciones realizadas por Supervisores por Fecha",
      "TITLEVALIDATIONS_3": "Demora(hs) Promedio en validar"
    },
    "DASH_TASKS": {
      "ADVANCED": "Avanzado",
      "SHOW_TEMPLATES": "Ver Templates",
      "NEW": "Nueva tarea",
      "TASK_NO_AUTHORIZED": "La tarea corresponde a otro departamento",
      "DIAG_DEL": {
        "TITLE": "Eliminar tarea",
        "BODY": "¿Desea eliminar la tarea?",
        "BODY_REPEAT": " Se borrarán todas las repeticiones tambien."
      },
      "DIAG_SAVE": {
        "TITLE": "Guardar tarea",
        "BODY": "¿Desea guardar la tarea?"
      },
      "MODAL": {
        "INFO": "Para crear una nueva tarea para un usuario de la App de Field, es necesario haber definido previamente el <strong>Sitio en donde dicha tarea debe ser realizada</strong>, y verificar que dicho usuario es parte de un Equipo que esta suscripto al Formulario que asociado a la Tarea."
      },
      "FIELDS": {
        "ADMIN": "Admin",
        "K": "K",
        "CONSTANT": "Constante",
        "FIELD_ID": "Field",
        "NAME": "Nombre",
        "NAME_TOOLTIP": "Seleccione un template de tarea o ingrese un nombre nuevo",
        "NAME_PLACEHOLDER": "Buscar template de tarea...",
        "DESCRIP": "Descripción",
        "DESCRIP_PLACEHOLDER": "Descripción de tarea",
        "FORM": "Formulario",
        "FORM_PLACEHOLDER": "Buscar formulario...",
        "SITE": "Sitio",
        "SELECT_SITE": "Seleccionar Sitio",
        "SELECT_SITE_COL": "Seleccionar columna con nombre de Sitio",
        "SITE_PLACEHOLDER": "Buscar sitio...",
        "INFO_SITE_COL": "Nombre de Sitio existente en la sección de Sitios",
        "ERROR_SITE_TITLE": "Error: Sitio",
        "ERROR_SITE_MESSAGE_START": "El sitio \"",
        "ERROR_SITE_MESSAGE_END": "\" no se encuentra cargado en la sección Sitios.\nCorrija el archivo y vuelva a realizar el proceso de carga del mismo.",
        "ERROR_FORM_TITLE": "Error: Formulario",
        "ERROR_FORM_MESSAGE_START": "El formulario \"",
        "ERROR_FORM_MESSAGE_END": "\" no se encuentra cargado en la sección Formularios.\nCorrija el archivo y vuelva a realizar el proceso de carga del mismo.",
        "ERROR_DEFAULT_TITLES": "Error: Columnas",
        "ERROR_DEFAULT_TITLES_BODY": "Los títulos de las columnas deben ser los mismos que se encuentran en el archivo de ejemplo, a continuación se pueden agregar columnas con metadatos.",
        "USER": "Usuario asignado",
        "USERS": "Usuarios",
        "DATE": "Fecha",
        "IMPORT_MODE": "Modo de importación",
        "AUTO_IMPORT": "Procesamiento automático del archivo",
        "MANUAL_IMPORT": "Selección manual",
        "MANUAL_SELECTION": "Manual",
        "DYNAMIC_SELECTION": "Dinámico",
        "CALENDAR": "Calendario",
        "ALL_DAY": "Todo el día",
        "NO_EXPIRATION": "Sin vencimiento",
        "START_DATE": "Inicio",
        "END_DATE": "Fin",
        "REPEAT": "Repetir",
        "REPEAT_EVERY": "Cada cuantos días",
        "REPEAT_TO": "Repetir hasta",
        "FIELD": "Campo",
        "FIELD_PLACEHOLDER": "Nombre del campo",
        "VALUE": "Valor",
        "VALUE_PLACEHOLDER": "Valor a asignar al campo",
        "METHOD": "Método",
        "URL": "URL",
        "AUTH": "Autorización",
        "QUERY_PARAMS": "Parámetros de Query",
        "HEADERS": "Headers",
        "PAYLOAD": "Payload",
        "FORMAT_JSON": "Formatear JSON"
      },
      "TEMPLATES": {
        "TITLE": "Templates de tareas",
        "NEW": "Nuevo template",
        "EDIT": "Editar template",
        "COPY": "Copiar template",
        "INFO": "Los Templates permiten agregar Valores a un Tarea a fin de que el usuario de la App de Field cuenta con información adicional asociada a la Tarea. Esto podría ser Nombre del Contacto, Consideraciones Especiales de la Tarea, etc. Los Templates se guardan y luego son utilizados cada vez que se quiere generar una tarea con esos valores asociados. Esta información aparece en la App móvil de Field.",
        "NO_INFO": "La no cuenta con ningun template para tareas. Por favor cree nuevos."
      }
    },
    "DASH_TASKS_ADVANCED": {
      "TITLE": "Tareas Avanzadas",
      "IMPORT_TITLE": "Importar",
      "IMPORT_FILE": "Importar Archivo",
      "IMPORT_FILE_MANUAL": "Importación Asistida",
      "IMPORT_FILE_AUTO": "Importación Automática",
      "EXPORT_FILE": "Exportar Registros",
      "TASK_GRID": "Grilla de Tareas",
      "USERS_ASSIGN": "Usuarios a Asignar a Tareas seleccionardas",
      "ASSIGN_SELECTED": "Asignar usuarios a Tareas seleccionadas",
      "DELETE": "Borrar Tareas seleccionadas",
      "BACK_TO_GRID": "Volver a Grilla de Tareas",
      "COLS": {
        "START": "INICIO",
        "END": "FIN",
        "TASK_NAME": "NOMBRE TAREA",
        "CLIENT": "SITIO",
        "FORM": "FORMULARIO",
        "DESCRIPTION": "DESCRIPCION",
        "USERS": "USUARIOS",
        "REPEAT": "REPITE",
        "TYPE": "TIPO",
        "ALL": "TODOS"
      },
      "REPETITIVE_TASKS": "Incluir tareas Repetitivas ya iniciadas",
      "FILTER_BUTTON": "Filtrar",
      "ASSIGN_USERS_TASKS": "Asignar Usuarios a las tareas seleccionadas",
      "REPLACE_PREVIOUS": "Reemplazar anteriores",
      "TASK_ITEMS": "Task items",
      "SELECT_ITEM": "Seleccione el item cargado",
      "IMPORT": {
        "SELECT_FILE": "Archivo a importar",
        "STEP_1": "1. Caracter separador de columnas",
        "STEP_2": "2. Archivo a subir",
        "STEP_2_SELECT_FILE": "Abrir Archivo",
        "DOWNLOAD_FILE": "Descargar archivo de ejemplo",
        "FILE_CONTENT": "Contenido del archivo",
        "INFO_MODAL_TITLE": "Manual básico de creación de archivos",
        "INFO_MODAL_PART_01": "El archivo que se va a importar debe tener una extensión de archivo ",
        "INFO_MODAL_PART_02": ".csv",
        "INFO_MODAL_PART_03": " y contener datos organizados en formato de tabla, donde las columnas estén separadas por ",
        "INFO_MODAL_PART_04": "tabulaciones",
        "INFO_MODAL_PART_05": " (TAB) o ",
        "INFO_MODAL_PART_06": "punto y coma",
        "INFO_MODAL_PART_07": " (;). Cada fila en el archivo representa un registro único de datos, con las columnas organizadas de manera coherente y consistente.",
        "INFO_MODAL_PART_08": "Por ejemplo, si estamos importando datos de una tarea, la estructura del archivo podría ser la siguiente:",
        "INFO_MODAL_PART_09": "En este ejemplo, cada fila representa una tarea distinta, y cada columna contiene información específica sobre la tarea, como el ID de la tarea, el estado, la región, entre otros.",
        "INFO_MODAL_PART_10": "Es esencial mantener esta estructura de archivo y asegurarse de que tenga la extensión .csv para garantizar una importación correcta de los datos en el sistema. Cada columna debe estar claramente delimitada por tabulaciones o puntos y coma, y se debe evitar cualquier espacio adicional antes o después de los valores. Esto facilitará el proceso de importación y asegurará que los datos se integren correctamente en el sistema.",
        "INFO_DATE": "Formato: AAAA-MM-DD o DD/MM/AAAA",
        "INFO_HOUR": "Formato: HH:mm o HH:mm:ss",
        "INFO_USERS": "Correo electrónico de usuario existente",
        "INFO_IMPORT_END": "Las tareas fueron cargadas y notificadas.",
        "ERROR_FORM": "Error: Formulario",
        "ERROR_FORM_TEXT": "Los campos Fecha, Inicio y Fin son requeridos.",
        "ERROR_FORM_TEMPLATE": "Debe seleccionar Template.",
        "ERROR_FORM_TASK_NAME": "Debe ingresar Nombre de Tarea.",
        "ERROR_FORM_TASK_DESC": "Debe ingresar Descripción de Tarea.",
        "ERROR_FORM_CALENDAR_DATE": "Debe ingresar Fecha.",
        "ERROR_FORM_CALENDAR_START": "Debe ingresar hora de Inicio.",
        "ERROR_FORM_CALENDAR_END": "Debe ingresar hora de Fin.",
        "ERROR_USERS_NOT_FOUND_TITLE": "Error: Usuarios no encontrados",
        "ERROR_USERS_NOT_FOUND_BODY": "Los siguientes emails no se encontraron en la base de datos, por lo que las tareas correspondientes quedaron sin asignar responsable: ",
        "ERROR_DATE_TITLE": "Error: Fecha",
        "ERROR_DATE_MESSAGE_START": "La fecha u hora de la fila ",
        "ERROR_DATE_MESSAGE_MID": " no es válida: ",
        "ERROR_DATE_MESSAGE_END": ". Use fecha AAAA-MM-DD o DD/MM/AAAA y hora HH:mm o HH:mm:ss.",
        "ERROR_DATE_API": "Las fechas de inicio y fin no se pudieron interpretar. Use AAAA-MM-DD o DD/MM/AAAA y hora HH:mm o HH:mm:ss.",
        "ERROR_SAVE_TITLE": "Error al importar tareas",
        "ERROR_SAVE_BODY": "No se pudieron crear las tareas. Revise los datos e intente nuevamente.",
        "DATA_IMPORT": "Datos a importar",
        "PROCESS": "Procesar",
        "PREVIEW": "Vista previa",
        "CHOOSE_TEMPLATE": "Seleccionar Template",
        "INFO_ADMIN": "Al marcar la casilla, esta información estará disponible exclusivamente para el programador de tareas y no se mostrará en la interfaz móvil de la aplicación.",
        "TASK_NAME": "Nombre Tarea",
        "FORM": "Formulario",
        "DESCRIPTION_TASK": "Descripcion Tarea",
        "METADATA": "Metadata",
        "IMPORTED_COLUMN": "Columna Importada",
        "FIRST_LAST_REFERENCE": "Primer y Ultimo valor como referencia",
        "CHOOSE_ONE": "Elegir uno ya cargado",
        "CREATE_SITES": "<p>Se crearan sitios en base a la importacion. Debes completar de manera obligatoria el nombre. Estos tienen que tener algun parametro dinamico de la columna.<br />Por ejemplo en nombre, <i>WOM {col3}, {col4}</i></p><p>Si encuentra un sitio con el mismo nombre, usará el ya cargado.</p>",
        "CREATE_IMPORTED_DATA": "Crear uno basado en los datos importados",
        "GENERATE_TASKS": "Generar Tareas",
        "DELETE_FIRST_LINE": "Eliminar primera línea"
      },
      "DIALOG_CONFIRM": {
        "BODY": "Se eliminará toda la información del archivo cargado. ¿Desea continuar?"
      }
    },
    "DASH_TEAM": {
      "TITLE": "Administre su equipo",
      "ADD": "Agregar usuarios",
      "FIND": "Busque los usuarios que desea incorporar al equipo",
      "NO_INFO": "No cuenta con ningun miembro.",
      "FIELDS": {
        "NAME": "Nombre",
        "EMAIL": "Email",
        "DEVICE": "Dispositivo asociado"
      },
      "RELEASE_DEVICE": "Desvincular dispositivo movil",
      "ACCOUNT": "Cuenta asociada",
      "DEL_TITLE": "Eliminar usuario",
      "DEL_BODY": "¿Desea eliminar al usuario {{email}} del grupo?",
      "DESV_TITLE": "Desvincular usuario de dispositivo",
      "DESV_BODY": "Desea desvincular al usuario {{userName}} del dispositivo actual?",
      "DESV_ACCEPT": "Desvincular",
      "LEADER": "Responsable de equipo"
    },
    "DASH_TEAMS": {
      "TITLE": "Equipos",
      "TITLE_TOOLTIP": "Agregue usuarios a un equipo y luego subscriba el equipo a un formulario.",
      "NEW": "Nuevo Equipo",
      "IN_NAME": "Ingrese el nombre del nuevo equipo",
      "SECTION_INFO": "<p>El módulo de Equipos se usa para definir los usuarios que podrán acceder y usar los formularios desde la App de Field.</p><p>Todo usuario de la App móvil debe pertenecer a un equipo. Los equipos son administrados por el Dueño de un departamento o por el Administrador. Un equipo puede tener tantos usuarios como se desee.</p><p>Por ejemplo, el Dueño del Departamento de Marketing puede definir un equipo para los promotores de la Zona Norte (nombre del equipo) y otro equipo para la Zona Sur (otro nombre de equipo). De esa forma, cuando crea un formulario, define qué equipo está autorizado a ver y usar ese formulario desde su dispositivo móvil.</p>",
      "NO_INFO": "El departamento no cuenta con ningun equipo. Por favor cree uno.",
      "COLS": {
        "NAME": "Nombre",
        "MEMBERS": "Miembros"
      },
      "DIAG_DEL": {
        "TITLE": "Eliminar Equipo",
        "BODY": "Al eliminar el equipo los usuarios del mismo no tendrán más acceso a los formularios a los cuales se encuentra subscripto.",
        "ACCEPT": "Eliminar Equipo"
      },
      "MODAL": {
        "TITLE_EDIT": "Editar nombre del equipo"
      }
    },
    "DASH_USERS": {
      "TITLE": "Administre sus usuarios",
      "TITLE_2": "Usuarios",
      "TITLE_3": "Permisos y Asignaciones",
      "TITLE_4": "Estadísticas",
      "COMPANIES": "Empresas",
      "PASSWORD_REQUIRED": "La contraseña es obligatoria",
      "NO_INFO": "La no cuenta con ningun usuario. Por favor invite nuevos.",
      "SECTION_INFO": "<p>El Modulo de usuarios permite administrar (dar de alta, baja y modificar) los usuarios del sistema. </p><p>Hay tres tipos de usuarios.</p><p><strong>Administrador:</strong> Puede dar de alta o invitar usuarios. Una vez que el usuario recibe la invitación por mail y se registra, el Administrador puede darle privilegios de Administrador, Dueño (de Departamento) o Supervisor (de Departamento). Un Administrador puede también crear, editar y borrar formularios, crear Equipos y crear Departamentos. Tanto un Administrador como un Dueño pueden desvincular dispositivos. Esto es desasociar un dispositivo de su usuario para que el mismo puede ser usado por otro usuario.</p> <p><strong>Dueño:</strong> Puede dar de alta usuarios y crear Equipos solo para su Departamento. Puede también crear, editar y borrar formularios. Puede ver y bajar datos a su PC.</p> <p><strong>Supervisor:</strong> Solo puede ver formularios y ver y bajar datos.</p> <p><strong>Mobile:</strong> Solo puede usar la App de Field, una vez que ha sido incorporado a un Equipo y su Equipo ha sido suscripto a un Formulario. No puede acceder a la web de Field.</p> ",
      "COMPANY": {
        "COMPANY": "Empresa",
        "ADD_COMPANY": "Nueva Empresa",
        "EDIT_COMPANY": "Editar Empresa",
        "NAME": "Nombre",
        "CODE": "Código",
        "NO_COMPANIES": "No se encontraron empresas",
        "ERROR_COMPANY_NEW": "No se pudo crear la empresa",
        "ERROR_COMPANY_MODIFY": "No se pudo modificar la empresa",
        "ERROR_COMPANY_DELETE": "No se pudo eliminar la empresa",
        "DIAG_DEL": {
          "TITLE": "Eliminar empresa",
          "BODY": "Solo se pueden eliminar empresas que no tengan usuarios asociados."
        }
      },
      "COLS": {
        "ACTIVE": "Activo",
        "CLIENTS": "Sitios",
        "CECO": "Centro de Costo",
        "REGION": "Region",
        "NAME": "Nombre",
        "FIRSTNAME": "Nombre",
        "LASTNAME": "Apellido",
        "COMPANY": "Empresa",
        "OFFICE": "Oficina",
        "DEPARTMENT": "Departamento",
        "TITLE": "Puesto",
        "EMPLOYEENUMBER": "Legajo",
        "EMAIL": "Email",
        "DISP_ASOC": "Dispositivo asociado",
        "LAST_LOGON": "Ultimo login",
        "CREATED_AT": "Creado",
        "PRIVILEGES": "Privilegios",
        "PASSWORD": "Nueva clave",
        "COMBO": {
          "SELECTION": "Seleccion",
          "MAKE_ADMIN": "Dar Admin",
          "UNMAKE_ADMIN": "Quitar Admin"
        },
        "RELEASE_DEVICE": "Desvincular dispositivo movil",
        "ASSOC_ACCOUNT": "Cuenta Asociada"
      },
      "STATISTICS": {
        "TITLE": "Estadísticas de Usuarios",
        "TITLE_TENANT": "Estadísticas de Tenant: ",
        "ACTIVE": "Usuarios Activos",
        "CREATED": "Usuarios Creados",
        "DELETED": "Usuarios Eliminados",
        "INACTIVE": "Usuarios Inactivos",
        "CREATED_DELETED_INACTIVE": "Usuarios Creados/Eliminados/Inactivos",
        "TOTAL": "Total de Items",
        "ITEMS": "Items",
        "FORM": "Formulario",
        "USER": "Usuario",
        "DATA_LIST": "Lista de Datos",
        "DATES_ERROR": "Error en fechas ingresadas. No pueden superar la fecha actual, y deben tener un intervalo máximo de 3 meses."
      },
      "ACCESS_LOG": {
        "TRANSACTIONS": "Transacciones de Usuarios",
        "USER_STATISTICS_ERROR": "Error al obtener información de estadísticas de usuarios:",
        "USERS_WITH_MOVEMENTS": "Cantidad de Usuarios con Movimientos",
        "USERS_WITH_VALIDATIONS": "Cantidad de Usuarios con Validaciones",
        "USERS_WITH_CREATIONS": "Cantidad de Usuarios con Items Creados",
        "ACCESS_ERROR": "Error al obtener información de logs de acceso"
      },
      "NOTIFICATION": {
        "TITLE": "Enviar Notificacion Push a los moviles",
        "MSG_TITLE": "Titulo del mensaje",
        "MSG_BODY": "Cuerpo del mensaje",
        "SEND": "Enviar mensaje"
      },
      "INVITE": {
        "BT": "Invitar usuario",
        "TITLE": "Invitar usuarios a la cuenta",
        "IN_EMAIL": "Ingrese el email de los usuarios que desea invitar",
        "IN_EMAIL_TOOLTIP": "Ingrese un mail y presione enter. Puedes ingresar varios separandolos por coma.",
        "IN_EMAIL_PLACEHOLDER": "Busque usuarios",
        "ADD_USER": "Agregar usuarios"
      },
      "NEW": {
        "BT": "Nuevo usuario",
        "TITLE": "Alta de usuarios a la cuenta",
        "ADD_USER": "Agregar usuario"
      },
      "EDIT": {
        "TITLE": "Editar usuario"
      },
      "SITES": {
        "TITLE": "Sitios",
        "HELP": "Seleccione los sitios a los que pertenece el usuario"
      },
      "API_TOKEN": {
        "TITLE": "API Token",
        "GENERATE": "Generar token",
        "SHOW": "Mostrar token",
        "HIDE": "Ocultar token",
        "COPY": "Copiar token",
        "COPIED": "Token copiado",
        "COPY_ERROR": "No se pudo copiar el token",
        "DELETE": "Eliminar token",
        "GENERATE_ERROR": "No se pudo generar el token",
        "DELETE_ERROR": "No se pudo eliminar el token",
        "DIAG_DEL": {
          "TITLE": "Eliminar API Token",
          "BODY": "¿Desea eliminar el API Token? Deberá generar uno nuevo para volver a usarlo.",
          "ACCEPT": "Eliminar"
        }
      },
      "DIAG_MAKEADMIN": {
        "TITLE": "Hacer administrador",
        "BODY": "¿Desea modificar los privilegios?",
        "ACCEPT": "Hacer Administrador"
      },
      "DIAG_UNMAKEADMIN": {
        "TITLE": "Quitar administrador",
        "BODY": "¿Desea modificar los privilegios?",
        "ACCEPT": "Quitar rol Administrador"
      },
      "DIAG_REL_DEV": {
        "TITLE": "Desvincular usuario de dispositivo",
        "BODY": "Desea desvincular al usuario {{userName}} del dispositivo actual?",
        "ACCEPT": "Desvincular"
      },
      "DIAG_REMOVE_USER": {
        "TITLE": "Eliminar usuario",
        "BODY": "¿Desea eliminar los usuarios? {{usersEmail}}",
        "ACCEPT": "Eliminar"
      }
    },
    "DASH_WEBHOOKS": {
      "TITLE": "Administre sus webhooks",
      "TITLE_2": "Webhooks",
      "NO_INFO": "La no cuenta con ningun webhook. Por favor cree uno.",
      "SECTION_INFO": "<p>El modulo de Webhooks amplia significativamente el alcance de Field permitiendo el envio de notificaciones en tiempo real, cada vez que se sube un ítem.</p><p>Algunos ejemplos de lo que permiten los webhooks:</p>     <ul> <li>Guardar los ítems (datos tomados en campo desde la app de Field) en la base de datos del cliente a medida que se van subiendo desde el dispositivo movil.</li><li>Activar alarmas internas al recibir un ítem con determinadas características.</li><li>Actualizar datos en sistema de gestión de la empresa en tiempo real.</li><li>Puede generar reportes o enviar mails con datos importantes a medida que se van subiendo los ítems.</li>      </ul>      <p>Para configurar el webhook usted necesita un servidor con un endpoint que soporte requests GET y POST. Al momento de crear el webhook se enviará un request GET.</p>      <p>La url del request incluirá queries con los valores challenge y verify_token.</p>      <p>Para poder crear el webhook correctamente, el servidor debe responder con un status 200 y el challenge enviado en el body. El verify_token es para uso personal del cliente, y permite asegurarse que el request fue configurado por el administrador de Field en la empresa.</p>      <p>Una vez creado el Webhook con éxito, se debe ir a la sección de Formularios y subscribir los mismos a webhooks. Cada vez que se suba un ítem, el mismo sera enviado en el body de un POST a su servidor.</p>",
      "COLS": {
        "TYPE": "Tipo",
        "CALLBACK": "Callback URL",
        "COMBO": {
          "TYPE_FORM": "Formularios",
          "TYPE_NA": "Sin Tipo"
        }
      },
      "NEW": {
        "BT": "Nuevo webhook"
      },
      "TITLE_NEW": "Agregar nuevo webhook",
      "TITLE_EDIT": "Editar webhook",
      "TOKEN": "Token de verificación",
      "DIAG_REMOVE": {
        "TITLE": "Eliminar WebHook",
        "BODY": "¿Desea eliminar el webhook?"
      }
    },
    "DASH_WIZARD": {
      "HELP_CENTER": {
        "TITLE": "Centro de Ayuda",
        "TITLE_2": "¿Cómo empezar?"
      },
      "TITLE": "Wizard",
      "TITLE_2": "Uso del Wizard",
      "TUTORIALS": "Tutoriales",
      "VIEW_PLAYLIST": "Ver lista de reproducción completa",
      "SECTION_INFO": "Para empezar a recolectar datos desde un dispositivo movil usando la app de Field es necesario definir previamente algunos componentes.<br />Estos son:<br /><br /><ol><li>Departamento dentro de la organización para la cual se toman los datos.</li><li>Usuarios, que luego podrán ser definidos como Dueños o de lo contrario son los responsables de tomar datos de campo con los dispositivos móviles.</li><li>Dueño o responsable del Departamento. El dueño de un Departamento es el responsable de dar de alta usuarios y sitios, generar formularios, definir equipos, y crear y asignar tareas a los usuarios. (Ej. Mantenimiento).</li><li>Nombre de los Equipos, formados por usuarios, asociados a los Departamentos y y que tienen los privilegios para acceder a los formularios. (Ej. Técnicos Mantenimiento).</li><li>Miembros de los Equipos, usuarios que forman los equipos. (Un usuario puede pertenecer a mas de un equipo).</li><li>Crear el Formulario.</li><li>Suscribir el Equipo al Formulario.</li></ol>",
      "START": "Empezar",
      "START_DENIED": "Necesitas permisos de administrador o de dueño para poder empezar a configurar.",
      "NOSELECT_ERR_TOAST": {
        "DEPT": "No ha seleccionado un Departamento",
        "OWNER": "No ha asignado a un Dueño",
        "USERS_OK": "No se encontraron Usuarios confirmados",
        "TEAM": "No se seleccionó Equipo",
        "TEAM_USERS": "No se asignaron Usuarios al Equipo"
      },
      "DEPARTMENT": {
        "TITLE": "Creación de Departamentos",
        "SELECT_DEPT_TOAST": "Departamento seleccionado",
        "INFO": "Crear un Departamento nuevo o seleccionar uno existente para asignarle Dueño, Equipos y Formularios.",
        "TITLE_2": "Lista de departamentos ya creados:",
        "NEW": "Crear Nuevo Departamento"
      },
      "USERS": {
        "TITLE": "Invitación de Usuarios",
        "INVITE_DUPLICATE_ERR_TOAST": "El email utilizado ya pertenece a una cuenta de Field.",
        "INVITE_ERR_TOAST": "Error al consultar email.",
        "INVITE_OK_TOAST": "El o los usuarios indicados han sido invitados",
        "INFO": "Para invitar a un usuario hay que ingresar su cuenta de correo electrónico.  El usuario recibirá un mail, el cual deberá ser confirmado registrando su nombre y una contraseña. Hasta que el invitado no confirme el mail y registre su nombre y contraseña, su nombre aparecerá en la lista como \"Por Confirmar\".",
        "TITLE_2": "Lista de Usuarios confirmados:"
      },
      "OWNER": {
        "TITLE": "Asignación de Dueño de Departamento",
        "INFO": "El dueño de un Departamento es el responsable de dar de alta usuarios y sitios, y también de generar formularios, definir equipos, y crear y asignar tareas a los usuarios.",
        "TITLE_2": "Lista de Dueños del Departamento:",
        "INFO_2": "Al contar con al menos un Dueño asignado, es posible continuar con el paso siguiente.",
        "INFO_3": "Al no contar con al menos un Dueño asignado, debe asignar uno para continuar con el paso siguiente."
      },
      "TEAM": {
        "TITLE": "Creación de Equipos",
        "SELECT_OK": "Equipo seleccionado",
        "INFO": "El módulo de equipos se usa para habilitar o dar permiso a un grupo de usuarios de utilizar un formulario dado. Todo usuario debe pertenecer a un equipo. Los equipos son administrados por el Dueño de un departamento y estan asociados a ese Departamento.",
        "INFO_2": "El Departamento seleccionado no posee Equipos, asigne uno para poder continuar",
        "TITLE_2": " Lista de Equipos del Departamento:"
      },
      "TEAMUSERS": {
        "TITLE": "Asignación de Usuarios",
        "INFO": "Todo Equipo debe tener asignado al menos un usuario.",
        "INFO_2": "El Equipo seleccionado no posee usuarios asignados, asigne uno para poder continuar",
        "TITLE_2": "Lista de Usuarios asignados al Equipo:"
      },
      "FORMS": {
        "TITLE": "Creación de Formularios",
        "SELECT_OK": "Formulario Seleccionado",
        "DIAG_NEW": {
          "TITLE": "Crear formulario",
          "BODY": "¿Desea crear un formulario?",
          "ACCEPT": "Crear"
        },
        "INFO": "Por último puede configurar un nuevo Formulario o seleccionar alguno entre los creados para el Departamento seleccionado.",
        "INFO_2": "El Departamento seleccionado no posee Formularios.",
        "TITLE_2": "Lista de Formularios del Departamento:"
      }
    },
    "DASH_VALIDATIONS": {
      "TITLE": "Validaciones pendientes",
      "INFO": "Módulo de validaciones de Field.",
      "VALIDATE": "Validar",
      "VALIDATE_MULTI": "Validación múltiple",
      "VALIDATED": "Validados",
      "NO_GRAPHS_TITLE": "No hay tableros disponibles",
      "NO_GRAPHS_MESSAGE": "Sus departamentos no poseen tableros. Por favor, cree tableros en los departamentos para poder visualizarlos aquí.",
      "NO_DEPT_GRAPHS": "El departamento seleccionado no posee tableros",
      "NO_FORMS_TITLE": "No hay formularios disponibles",
      "NO_FORMS_MESSAGE": "Sus departamentos no poseen formularios. Por favor, cree formularios en los departamentos para poder visualizarlos aquí.",
      "NO_DEPT_FORMS": "El departamento seleccionado no posee formularios",
      "STATES": {
        "PENDING": "Pendiente",
        "OK": "Aprobado",
        "REJECT": "Rechazado"
      },
      "STAGE_CHANGED": "El registro ya fue validado o cambió de etapa. Actualice la vista e intente nuevamente.",
      "COLS": {
        "DATE": "Fecha",
        "VALIDATION_DATE": "Validación",
        "TYPE": "Tipo",
        "USER": "Usuario",
        "SUPPLIER": "Proveedor",
        "ID": "ID",
        "SECTION": "Sector",
        "DEPARTMENT": "Departamento",
        "RECORDS": "Registros de",
        "TITLE": "Titulo del registro",
        "AGREEMENT": "Contrato",
        "ASSET": "Área",
        "COMPANY": "Proveedor",
        "STATE": "Estado"
      },
      "FILTER_STATE": "Filtrar por estado"
    },
    "DIRECTIVES": {
      "SIGN_VALIDATE": {
        "SIGN": "Firmar",
        "NO_SIGN": "Sin Firmar",
        "CLEAR": "Limpiar"
      },
      "FILE_VALIDATE": {
        "UPLOAD": "Subir Archivo",
        "NO_FILE": "Sin Archivos",
        "UPLOADING": "Subiendo",
        "DOWNLOAD": "Descargar",
        "DELETE": "Eliminar",
        "ATTACHMENTS": "Archivos adjuntos"
      }
    }
  }
}